
var checkTextFlg = false;

//modal.jsにて必要
function checkText() {
 if(!checkTextFlg) {
   alert("価格が算出されていません。\nご希望のサイズを入力／カラーを選択後、価格算出ボタンを押してください。");
   return false;
 }     
 return true;
}
  
 //材質切替
window.onload = function(){
  document.getElementById("material").innerHTML = "選択してください";
  document.getElementById("material_leg").innerHTML = "選択してください";
  document.getElementById("material_maku").innerHTML = "選択してください";
  }
$(function(){//jQuery開始

  const strLink1="https://interior-arne.com/products/"
  var priceList;//価格情報

  function init(){
    $("#linkmsg").text();
    $("#linkmsg").hide();
    $("#sizemsg").hide();
    $("#opmsg").hide();
    $("#op_psimsg").hide();
    $("#op_box").hide();
    
    $.ajax({// 価格情報読込
      url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_price_15e3f314-d4f6-4998-b9c0-76ff489e9471.csv?v=1792547348",
      dataType : 'text',
      success: function(data) {
        priceList = $.csv.toArrays(data);        
      }
    });
  
    
    $.ajax({// メラミン天板価格情報読込
      url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_metop_ea864187-3e45-4531-891d-3611af6b36b9.csv?v=1792547684",
      dataType : 'text',
      success: function(data) {
        metopList = $.csv.toArrays(data);
      }
    });
    
    $.ajax({// メラミン脚価格情報読込
      url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_meleg_829c5505-bf94-4cc9-931e-31366de95837.csv?v=1792547797",
      dataType : 'text',
      success: function(data) {
        melegList = $.csv.toArrays(data);
      }
    });
    
    $.ajax({// メラミン幕板価格情報読込
      url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_memak_c50dc4f2-1ddb-4662-9450-e4d8dbed19bd.csv?v=1792547781",
      dataType : 'text',
      success: function(data) {
        memakList = $.csv.toArrays(data);
      }
    });
  }
  $(init);  

  // リセット処理
  function cartReset(){
//  console.log("cartReset");
    $("#price").val("");
    $("#cart_price").html(" 円");
    var result =$("#check_list").find(".result");
    result.eq(0).text("");
    result.eq(1).text("");
    result.eq(2).text("");
    result.eq(3).text("");
    result.eq(4).text("");
    result.eq(5).text("");
    result.eq(6).text("");
    result.eq(7).text("");
    result.eq(8).text("");
    result.eq(9).text("");
    result.eq(10).text("");
    result.eq(11).text("");
    $("#linkmsg").hide();
    panel_ichi="";
    checkTextFlg = false;
  }

//入力3桁以内指定
$("#step2 input").on('input', function(e) { 
  var value = $(this).val()
  if (value > 3) {
    $(this).val(value.slice(0, 3))
  }
})
$("#step6 input").on('input', function(e) { 
  var value = $(this).val()
  if (value > 3) {
    $(this).val(value.slice(0, 3))
  }
})



  // dataInfo[0]:0:ストレート／1:台形 //脚の形
  // dataInfo[1]:cm // 幅:W
  // dataInfo[2]:cm // 奥行:D
  // dataInfo[3]:cm // 高さ:H
  // dataInfo[4]:0:背面／1:中央 //幕板位置
  // dataInfo[5]:0:ショート／1:ハーフ／2:ロング //幕板サイズ
  // dataInfo[6]:0:インデックス //天板カラー
  // dataInfo[7]:0:インデックス //脚形
  // dataInfo[8]:0:インデックス //幕板カラー
  var dataInfo = [0, 100, 60, 75, 0, 0, 0, 0, 0];
  var opInfo = [0,0,0,0];//オプション選択
  var sizeFlg = [false,false,false,false,true];//各サイズの入力チェック用
  var colorFlg = [false,false,false]//各色の入力チェック用
  
  //▼脚の形を選択▼
  $("#step1 input").change(function(){
    cartReset();
	checkSize();
    var idx = $("#step1 input").index(this);

    if(idx==1){//台形の場合
      $("#mak_ichi").attr("disabled",true);$("#mak_ichi").val("中央");
      dataInfo[4]=1;
/*穴位置リセット動作追加2023/02/14*/
	$("input[name='op_panel']").prop("checked",false);
          $("#op_psimsg").hide();
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
//      $("#step6 input").eq(1).parent().hide();
//      $("#step6 input").eq(1).prop('checked', false);
    }else{
      $("#mak_ichi").attr("disabled",false);
//      $("#mak_ichi").val("背面");
//      dataInfo[4]=0;
      $("#step6 input").eq(1).parent().show();
    }
    dataInfo[0]=idx;
    showImage();
  });

  //ご希望サイズの入力
  $("#step2 input").change(function(){
    cartReset();
    var idx = $("#step2 input").index(this);
    var num = $("#step2 input").eq(idx).val();
    if(!isNaN(num) && num!=""){
      if(idx==2){calcMakHeight();}
      switch(idx){
        case 0:dataInfo[1]=Number(num);sizeFlg[idx]=true;break;
        case 1:dataInfo[2]=Number(num);sizeFlg[idx]=true;break;
        case 2:dataInfo[3]=Number(num);sizeFlg[idx]=true;break;
        case 3:dataInfo[5]=Number(num);sizeFlg[idx]=true;break;
      }
    }else{
      sizeFlg[idx]=false;
      switch(idx){
        case 0:dataInfo[1]=Number(100);break;
        case 1:dataInfo[2]=Number(60);break;
        case 2:dataInfo[3]=Number(75);break;
      }
    }

    $(".size_img").find("img").eq(4).hide();
    checkSize();
    showImage();
  });

  $("#mak_ichi").change(function(){
    cartReset();
/*穴位置リセット動作追加2023/02/14*/
	$("input[name='op_panel']").prop("checked",false);
          $("#op_psimsg").hide();
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
    dataInfo[4]=$('#mak_ichi option:selected').index();
    showImage();
  });

  $("#mak_size").change(function(){
    cartReset();
    calcMakHeight();
    dataInfo[5]= $('#mak_size option:selected').index();
    checkSize();
    showImage();
  });

  //リアルタイムサイズチェック
  function checkSize(){
    var sizemsg = "";
    var size;
    var errorFlg = false;
    $("#step2 input").each(function(idx,ele){
      size = $(ele).val();
      if(size == ""){return true;}
      if(idx > 2){return false;}
      switch(idx){
        case 0:
          if(size < 30 || 150 < size ){
            sizemsg += "<p>※ 幅30cm未満・幅151cm以上はオーダー不可です ※</p>";
            dataInfo[1]=100;
            sizeFlg[idx]=false;
            errorFlg=true;
          }
          break;
        case 1:
		  checkLeg = $("input[name='option1']:checked").val();
		  if( checkLeg == "台形" && size < 30 ){
            sizemsg += "<p>※ 台形脚選択の場合、奥行30cm未満はオーダー不可です ※</p>";
            dataInfo[2]=60;
            sizeFlg[4]=false;
            errorFlg=true;
          }
		  if( checkLeg == "台形" && size > 30 ){
            sizeFlg[4]=true;
          }
		  if( checkLeg == "ストレート" ){
            sizeFlg[4]=true;
          }
          if(size < 15 || 90 < size  ){
            sizemsg += "<p>※ 奥行15cm未満・奥行91cm以上はオーダー不可です ※</p>";
            dataInfo[2]=60;
            sizeFlg[idx]=false;
            errorFlg=true;
          }
          break;
        case 2:
          if(size < 40 || 100 < size ){
            sizemsg += "<p>※ 高さ40cm未満・高さ101cm以上はオーダー不可です ※</p>";
            dataInfo[3]=75;
            sizeFlg[idx]=false;
            errorFlg=true;
          }
          if(89 < size && size < 101){
            var tmp = $('#mak_size option:selected').index();
            if(tmp==0){
              sizemsg += "<p>※ 高さ90cm以上の場合、ショートは選択できません ※</p>";
              //dataInfo[3]=75;
              sizeFlg[3]=false;
              errorFlg=true;
            }else if(tmp==1|tmp==2){
            	sizeFlg[3]=true;
            	}
          }
          if(89 > size){sizeFlg[3]=true;}
          break;
      }
    });
    if(errorFlg){
      $("#sizemsg").html(sizemsg);
      $("#sizemsg").show();
    }else{
      $("#sizemsg").html("<p> </p>");
      $("#sizemsg").hide();
    }
    return errorFlg;
  }

  //幕板サイズ表示
  function calcMakHeight(){
    var idx = $('#mak_size option:selected').index();
    var height = $("#height").val();
    var size = 0;
    if(height!="" && 39 < height && height < 101){
      switch(idx){
        case 0:size = Math.floor( height/3 ) ; break;
        case 1:size = Math.floor( height/2 ) ; break;
        case 2:size = height - 2; break;
      }
      $("#mak_height").val("約 "+size);
    }
  }

  //天板カラーの選択
  $("#step3 input").change(function(){
    cartReset();
    dataInfo[6]=$("#step3 input").index(this);
if( dataInfo[6] <= 7 ){
          $("#material").html("リーズナブル木目：<br>[材質]デルナチュレ化粧合板(ブラウン・ダークブラウン・北欧チーク)、強化紙化粧合板(ナチュラル・ホワイトウッド・オーク・ブラックウッド)、ポリエステル化粧合板(ホワイト)");
}else if( 8 <= dataInfo[6] && dataInfo[6] <= 13){
          $("#material").html("パステルカラーaino：<br>[材質]プリント化粧合板");
}else if( 14 <= dataInfo[6]){
          $("#material").html("ハイグレード鏡面仕上げ：<br>[本体]メラミン樹脂化粧合板 [背板]プリント化粧合板");
}
//カラー選択肢動作追加
	  var ten;
	  var asi;
	  var mak;
	  if(dataInfo[6] <= 13){ten=1;}
	  else if(14 <= dataInfo[6]){ten=2;}
	  else{ten=0;}
	  
	  if(dataInfo[7] <= 13){asi=1;}
	  else if(14 <= dataInfo[7]){asi=2;}
	  else{asi=false;}
	  
	  if(dataInfo[8] <= 13){mak=1;}
	  else if(14 <= dataInfo[8]){mak=2;}
	  else{mak=false;}
	  //天板が化粧紙だったら
	  if(ten == 1){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step4 input").eq(i).prop('checked', false);
		$("#step5 input").eq(i).prop('checked', false);
		}
        if( asi == 2 ){
        dataInfo[7]=0;
        $("#material_leg").html("選択してください");
	colorFlg[1] = false;
        }
        if( mak == 2){
	dataInfo[8]=0;
        $("#material_maku").html("選択してください");
	colorFlg[2] = false;
        }
	  }
	  //天板がメラミンだったら
	  else if(ten == 2){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step4 input").eq(i).prop('checked', false);
		$("#step5 input").eq(i).prop('checked', false);
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
        if( asi == 1 ){
        dataInfo[7]=14;
        $("#material_leg").html("選択してください");
	colorFlg[1] = false;
        }
        if( mak == 1){
	dataInfo[8]=14;
        $("#material_maku").html("選択してください");
	colorFlg[2] = false;
        }
	  }
	  

    colorFlg[0]= true;
    showImage();
  });
  
  //脚カラーの選択
  $("#step4 input").change(function(){
    cartReset();
    dataInfo[7]= $("#step4 input").index(this);
if( dataInfo[7] <= 7 ){
          $("#material_leg").html("リーズナブル木目：<br>[材質]デルナチュレ化粧合板(ブラウン・ダークブラウン・北欧チーク)、強化紙化粧合板(ナチュラル・ホワイトウッド・オーク・ブラックウッド)、ポリエステル化粧合板(ホワイト)");
}else if( 8 <= dataInfo[7] && dataInfo[7] <= 13){
          $("#material_leg").html("パステルカラーaino：<br>[材質]プリント化粧合板");
}else if( 14 <= dataInfo[7]){
          $("#material_leg").html("ハイグレード鏡面仕上げ：<br>[本体]メラミン樹脂化粧合板 [背板]プリント化粧合板");
}
//カラー選択肢動作追加
	  var ten;
	  var asi;
	  var mak;
	  if(dataInfo[6] <= 13){ten=1;}
	  else if(14 <= dataInfo[6]){ten=2;}
	  else{ten=0;}
	  
	  if(dataInfo[7] <= 13){asi=1;}
	  else if(14 <= dataInfo[7]){asi=2;}
	  else{asi=false;}
	  
	  if(dataInfo[8] <= 13){mak=1;}
	  else if(14 <= dataInfo[8]){mak=2;}
	  else{mak=false;}
	  //脚が化粧紙だったら
	  if(asi == 1){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step5 input").eq(i).prop('checked', false);
		}
        if( ten == 2 ){
        dataInfo[6]=0;
        $("#material").html("選択してください");
	colorFlg[0] = false;
        }
        if( mak == 2){
	dataInfo[8]=0;
        $("#material_maku").html("選択してください");
	colorFlg[2] = false;
        }
	  }
	  //脚がメラミンだったら
	  else if(asi == 2){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step5 input").eq(i).prop('checked', false);
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
        if( ten == 1 ){
        dataInfo[6]=14;
        $("#material").html("選択してください");
	colorFlg[0] = false;
        }
        if( mak == 1){
	dataInfo[8]=14;
        $("#material_maku").html("選択してください");
	colorFlg[2] = false;
        }
	  }
    colorFlg[1]= true;
    showImage();
  });
  
  //幕板カラーの選択
  $("#step5 input").change(function(){
    cartReset();
    dataInfo[8]= $("#step5 input").index(this);
if( dataInfo[8] <= 7 ){
          $("#material_maku").html("リーズナブル木目：<br>[材質]デルナチュレ化粧合板(ブラウン・ダークブラウン・北欧チーク)、強化紙化粧合板(ナチュラル・ホワイトウッド・オーク・ブラックウッド)、ポリエステル化粧合板(ホワイト)");
}else if( 8 <= dataInfo[8] && dataInfo[8] <= 13){
          $("#material_maku").html("パステルカラーaino：<br>[材質]プリント化粧合板");
}else if( 14 <= dataInfo[8]){
          $("#material_maku").html("ハイグレード鏡面仕上げ：<br>[本体]メラミン樹脂化粧合板 [背板]プリント化粧合板");
}
//カラー選択肢動作追加
	  var ten;
	  var asi;
	  var mak;
	  if(dataInfo[6] <= 13){ten=1;}
	  else if(14 <= dataInfo[6]){ten=2;}
	  else{ten=0;}
	  
	  if(dataInfo[7] <= 13){asi=1;}
	  else if(14 <= dataInfo[7]){asi=2;}
	  else{asi=false;}
	  
	  if(dataInfo[8] <= 13){mak=1;}
	  else if(14 <= dataInfo[8]){mak=2;}
	  else{mak=false;}
	  //幕板が化粧紙だったら
	  if(mak == 1){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step5 input").eq(i).prop('checked', false);
		}
        if( ten == 2 ){
        dataInfo[6]=0;
        $("#material").html("選択してください");
	colorFlg[0] = false;
        }
        if( mak == 2){
	dataInfo[7]=0;
        $("#material_leg").html("選択してください");
	colorFlg[1] = false;
        }
	  }
	  //幕板がメラミンだったら
	  else if(mak == 2){
		for(i = 0; i<=13; i++){
		$("#step4 input").eq(i).parent().hide();
		$("#step5 input").eq(i).parent().hide();
		$("#step5 input").eq(i).prop('checked', false);
		}
		for(i = 14; i<= 19; i++){
		$("#step4 input").eq(i).parent().show();
		$("#step5 input").eq(i).parent().show();
		}
        if( ten == 1 ){
        dataInfo[6]=14;
        $("#material").html("選択してください");
	colorFlg[0] = false;
        }
        if( asi == 1){
	dataInfo[7]=14;
        $("#material_leg").html("選択してください");
	colorFlg[1] = false;
        }
	  }
    colorFlg[2]= true;
    showImage();
  });

  //オプション加工の選択
  $("#check_btn input").change(function(){
    cartReset();
    var idx = $("#check_btn input").index(this);
    switch(idx){
      case 2:$("#check_btn input").eq(3).prop('checked', false);opInfo[3]=0;break;
      case 3:$("#check_btn input").eq(2).prop('checked', false);opInfo[2]=0;break;
    }
    if($(this).prop('checked')){opInfo[idx]=1;
    }else{opInfo[idx]=0;}
    checkOption();
  });

  function checkOption(){
    var opmsg = "";
    var msgFlg = false;
    var panelFlg = false;
    $("#step6 input").each(function(idx,ele){
      if($(ele).prop('checked')){
        switch(idx){
          case 0:opmsg += "<p>配線切り欠きは天板中央への加工となります。</p>";msgFlg=true;break;
//        case 1:opmsg += "<p>脚の形が台形の場合、選択できません</p>;break;
          case 1:opmsg += "<p>詳細な位置希望がある場合は穴位置選択後、備考欄へ記入ください</p>";msgFlg=true;panelFlg=true;break;
          case 2:opmsg += "<p>※本体の高さに約5.2cmプラスとなります</p><p>※奥行41cm以上の場合、キャスター数は6つになります</p>";msgFlg=true;break;
          case 3:opmsg += "<p>※本体の高さに約5.2cmプラスとなります</p><p>※奥行41cm以上の場合、キャスター数は6つになります</p>";msgFlg=true;break;
        }
      }else{
	var checked = $("input[name='op_panel']:checked").val();
        switch(idx){
          case 1:
          $("input[name='op_panel']").prop('checked', false);
          $("#op_psimsg > p > span:nth-child(1)").html(" ");
          $("#op_positionL").val('');
          $("#op_positionU").val('');
          $("#op_positionS").val('');
          $("#op_psimsg").hide();
          break;
        }
    }
    });
    if(msgFlg){
      $("#opmsg").html(opmsg);
      $("#opmsg").show();
    }else{
      $("#opmsg").html("<p> </p>");
      $("#opmsg").hide();
    }
//202201追加
    if(panelFlg){
      $("#op_box").show();
    }else{
      $("#op_box").hide();
    }
//202201追加
//ラジオボタンがクリックされたらchoicePanel()関数を呼び出し
$(document).ready(function () {
  $("input[name='op_panel']").click(function () {
    cartReset();
    choicePanel();
  })
})

//202201追加
    function choicePanel() {
 //     $("#op_positionL").val("");
//      $("#op_positionU").val("");
      $("#op_positionS").val("");
      makuichi = $('#mak_ichi option:selected').index();
      value = $("input[name='op_panel']:checked").val();

		if(makuichi==0){
      switch (value) {
        case "panel_a":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Aを正面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_a_normal.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
          $('#hole_ichi').append($('<option>').html("穴位置：左中央").val("左中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央").val("中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
          $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
          $('#hole_ichi').append($('<option>').html("穴位置：右中央").val("右中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
          break;
        case "panel_b":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Bを側面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_b_back.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上(幕板後)").val("奥上(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央(幕板後)").val("奥中央(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下(幕板後)").val("奥下(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上(幕板前)").val("奥上(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央(幕板前)").val("奥中央(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下(幕板前)").val("奥下(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央").val("中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前上").val("手前上"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前中央").val("手前中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前下").val("手前下"));
          break;
        case "panel_c":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Cを側面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_c_back.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前上").val("手前上"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前中央").val("手前中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前下").val("手前下"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央").val("中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上(幕板前)").val("奥上(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央(幕板前)").val("奥中央(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下(幕板前)").val("奥下(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上(幕板後)").val("奥上(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央(幕板後)").val("奥中央(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下(幕板後)").val("奥下(幕板後)"));
          break;
        case "panel_d":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Dを上から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_d_back.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：左奥(幕板後)").val("左奥(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：左奥(幕板前)").val("左奥(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：左中央").val("左中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：左手前").val("左手前"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央奥(幕板後)").val("中央奥(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央奥(幕板前)").val("中央奥(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央").val("中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央手前").val("中央手前"));
          $('#hole_ichi').append($('<option>').html("穴位置：右奥(幕板後)").val("右奥(幕板後)"));
          $('#hole_ichi').append($('<option>').html("穴位置：右奥(幕板前)").val("右奥(幕板前)"));
          $('#hole_ichi').append($('<option>').html("穴位置：右中央").val("右中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：右手前").val("右手前"));
          break;
        default:
          $("#op_psimsg").hide();
          $("#op_psimsg > p > span:nth-child(1)").html(" ");
          break;
      }
			}else if(makuichi==1){
      switch (value) {
        case "panel_a":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Aを正面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_a_normal.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
          $('#hole_ichi').append($('<option>').html("穴位置：左中央").val("左中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央").val("中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
          $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
          $('#hole_ichi').append($('<option>').html("穴位置：右中央").val("右中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
          break;
        case "panel_b":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Bを側面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_b_center.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上").val("奥上"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央").val("奥中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下").val("奥下"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前上").val("手前上"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前中央").val("手前中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前下").val("手前下"));
          break;
        case "panel_c":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Cを側面から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_c_center.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前上").val("手前上"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前中央").val("手前中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：手前下").val("手前下"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥上").val("奥上"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥中央").val("奥中央"));
          $('#hole_ichi').append($('<option>').html("穴位置：奥下").val("奥下"));
          break;
        case "panel_d":
          $("#op_psimsg").show();
          $("#op_psimsg > p > span:nth-child(1)").html("板面：Dを上から見て<br><img src=https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/panel_d_center.png><br>");
          $('#hole_ichi > option').remove();
          $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
          $('#hole_ichi').append($('<option>').html("穴位置：左奥").val("左奥"));
          $('#hole_ichi').append($('<option>').html("穴位置：左手前").val("左手前"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央奥").val("中央奥"));
          $('#hole_ichi').append($('<option>').html("穴位置：中央手前").val("中央手前"));
          $('#hole_ichi').append($('<option>').html("穴位置：右奥").val("右奥"));
          $('#hole_ichi').append($('<option>').html("穴位置：右手前").val("右手前"));
          break;
        default:
          $("#op_psimsg").hide();
          $("#op_psimsg > p > span:nth-child(1)").html(" ");
          break;
      }					 
					 }
    }
  }
  $("#hole_ichi").change(function(){
    cartReset();
  });
  
 $("#op_psimsg input").change(function() {
        cartReset();
	});

  //画像表示処理
  function showImage(){
//  console.log("showImage");
    var topImg = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/h75/w100d60/top/br.png";
    var leftImg = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/h75/w100d60/leg/stl_br.png";
    var makImg = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/h75/w100d60/mkh/short_br.png";
    var rightImg = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/h75/w100d60/leg/str_br.png";

    var tmp = "";
    var errFlg = false;
    var w,h,d;
    var color = ["br","dbr","tk","nt","whw","wh","oak","bkw","aino_pk","aino_or","aino_ye","aino_gr","aino_bl","aino_gy","nail","bp","gs","mb","ww","black"];
    var mak = ["short","half","long"];
    var mk = ["/mkh/","/mkc/"];
    var leg = ["st","dk"];

    //高さH
    if(40 <= dataInfo[3] && dataInfo[3] <=  59){h="h55";
    }else if(60 <= dataInfo[3] && dataInfo[3] <=  89){h="h75";
    }else if(90 <= dataInfo[3] && dataInfo[3] <=  100){h="h90";
    }else {h="h75";}

    //横幅W
    if(30 <= dataInfo[1] && dataInfo[1] <=  60){w="w45";
    }else if(61 <= dataInfo[1] && dataInfo[1] <=  90){w="w75";
    }else if(91 <= dataInfo[1] && dataInfo[1] <=  120){w="w100";
    }else if(121 <= dataInfo[1] && dataInfo[1] <= 150){w="w130";
    }else {w="w100";}
    
    //奥行D
    if(15 <= dataInfo[2] && dataInfo[2] <=  30){d="d30";
    }else if(31 <= dataInfo[2] && dataInfo[2] <=  60){d="d60";
    }else if(61 <= dataInfo[2] && dataInfo[2] <=  90){d="d90";
    }else {d="d60";}
    
    tmp = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/hammer/" + h +"/" + w + d;
    topImg = tmp + "/top/" + color[dataInfo[6]] + ".png";
    leftImg  = tmp + "/leg/" + leg[dataInfo[0]] + "l_" + color[dataInfo[7]] + ".png";
    makImg   = tmp + mk[dataInfo[4]] + mak[dataInfo[5]] + "_"  + color[dataInfo[8]] + ".png";
    rightImg = tmp + "/leg/" + leg[dataInfo[0]] + "r_" + color[dataInfo[7]] + ".png";

    $(".size_img").find("img").eq(0).attr('src', topImg);
    $(".size_img").find("img").eq(1).attr('src', leftImg);
    $(".size_img").find("img").eq(2).attr('src', makImg);
    $(".size_img").find("img").eq(3).attr('src', rightImg);
  }
  
  //組立て用ハンマー(無料)の選択
  $("#step7 input").change(function(){
    cartReset();
  });

  //この条件で金額産出
  $(".jamp").click(function(){
    cartReset();
    jump();
  });

  //価格計算処理
  function calcPrice(){
    if(priceList == null){
      alert("価格情報の読込に失敗しています。管理者へ報告をお願いします。");
    }
    if(metopList == null){
      alert("価格情報の読込に失敗しています。管理者へ報告をお願いします。");
    }
    if(melegList == null){
      alert("価格情報の読込に失敗しています。管理者へ報告をお願いします。");
    }
    if(memakList == null){
      alert("価格情報の読込に失敗しています。管理者へ報告をお願いします。");
    }
    var price = 0;
    var w=0,h=0,d=0,ww=0,hh=0,dd=0,topd=0,topc=0,legd=0,legc=0,makh=0,makh2=0,makc=0;
    var errFlg = false;
    var tmp,toptmp,legtmp,maktmp;
	  
	//メラミン動作追加
	if( 14 <= dataInfo[6] && 14 <= dataInfo[7] && 14 <= dataInfo[8] ){
	//R3用上書き注意 //20220520メラミン大阪→福井工場へ変更。同一item_idとinnventory_idに。
	  $("#item_id").val("10109441");
	  $("#inventory_id").val("241075");
		//天板種類
		if(14 == dataInfo[6] | 15 == dataInfo[6] |19 == dataInfo[6]){topd=0;
		}else if(16 == dataInfo[6] | 17 == dataInfo[6] |18 == dataInfo[6]){topd=16;
		}else {errFlg=true;}
		//脚種類
		if(14 == dataInfo[7] | 15 == dataInfo[7] |19 == dataInfo[7]){legd=0;
		}else if(16 == dataInfo[7] | 17 == dataInfo[7] |18 == dataInfo[7]){legd=16;
		}else {errFlg=true;}
		//幕板種類
		if(14 == dataInfo[8] | 15 == dataInfo[8] |19 == dataInfo[8]){makh=0;
		}else if(16 == dataInfo[8] | 17 == dataInfo[8] |18 == dataInfo[8]){makh=18;
		}else {errFlg=true;}
		//幅W
		ww=String(dataInfo[1]);
		if(30 <= dataInfo[1] && dataInfo[1] <=  150){
			if(ww.slice(-1)>=1 && ww.slice(-1)<=4){w=parseInt(ww.slice(0,ww.length-1)) +"5";
			ww=(Math.floor(w/5))-6;}
			else if (ww.slice(-1)>=6 && ww.slice(-1)<=9){w=parseInt(ww.slice(0,ww.length-1)) + 1 +"0";
			ww=(Math.floor(w/5))-6;}
			else if(ww.slice(-1)=="0" | ww.slice(-1)=="5"){ww=(Math.floor(dataInfo[1]/5))-6;
    		}else {errFlg=true;}
		}else {errFlg=true;}
		//高さH
		hh=String(dataInfo[3]);
		if(40 <= dataInfo[3] && dataInfo[3] <=  100){
			if(hh.slice(-1)>=1 && hh.slice(-1)<=4){h=parseInt(hh.slice(0,hh.length-1)) +"5";
			hh=(Math.floor(h/5))-9;}
			else if (hh.slice(-1)>=6 && hh.slice(-1)<=9){h=parseInt(hh.slice(0,hh.length-1)) + 1 +"0";
			hh=(Math.floor(h/5))-9;}
			else if(dataInfo[3]==40){hh=0;}
			else if(hh.slice(-1)=="0" | hh.slice(-1)=="5"){hh=(Math.floor(dataInfo[3]/5))-9;
    		}
    		else {errFlg=true;}
		}else {errFlg=true;}
        //奥行D
		dd=String(dataInfo[2]);
		if(15 <= dataInfo[2] && dataInfo[2] <=  90){
			if(dd.slice(-1)>=1 && dd.slice(-1)<=4){d=parseInt(dd.slice(0,dd.length-1)) +"5";
			dd=(Math.floor(d/5))-3;}
			else if (dd.slice(-1)>=6 && dd.slice(-1)<=9){d=parseInt(dd.slice(0,dd.length-1)) + 1 +"0";
			dd=(Math.floor(d/5))-3;}
			else if(dd.slice(-1)=="0" | dd.slice(-1)=="5"){dd=(Math.floor(dataInfo[2]/5))-3;
    		}else {errFlg=true;}
		}else {errFlg=true;}

  //幕板サイズ
    var idx = $('#mak_size option:selected').index();
    var height = $("#height").val();
    var size = 0;
    if(height!="" && 39 < height && height < 101){
      switch(idx){
        case 0:size = Math.floor( height/3 ) ; break;
        case 1:size = Math.floor( height/2 ) ; break;
        case 2:size = height - 2; break;
      }
		size=String(size);
    }
	if(13 <= size && size <= 100){
		if(size.slice(-1)>=1 && size.slice(-1)<=4){makh2=parseInt(size.slice(0,size.length-1)) +"5";
		size=(Math.floor(makh2/5))-3;}
		else if (size.slice(-1)>=6 && size.slice(-1)<=9){makh2=parseInt(size.slice(0,size.length-1)) + 1 +"0";
		size=(Math.floor(makh2/5))-3;}
		else if(size.slice(-1)=="0" | size.slice(-1)=="5"){size=(Math.floor(size/5))-3;
    	}else {errFlg=true;}
    }else {errFlg=true;}
		
		topc = topd+dd;
		legc = legd+dd;
		makc = makh+size;
													 
    if(!errFlg){
      toptmp = metopList[topc][ww];
      legtmp = melegList[legc][hh] * 2;
	  maktmp = memakList[makc][ww];
      price = parseInt(toptmp) + parseInt(legtmp) + parseInt(maktmp);
	}

}
	  
	//メラミン以外の価格動作
	else if( dataInfo[6] <= 13 && dataInfo[7] <= 13 && dataInfo[8] <= 13 ){
	//R3用上書き注意
	  $("#item_id").val("10109441");
	  $("#inventory_id").val("241075");
    //高さH
    if(40 <= dataInfo[3] && dataInfo[3] <=  59){h=0;
    }else if(60 <= dataInfo[3] && dataInfo[3] <=  89){h=16;
    }else if(90 <= dataInfo[3] && dataInfo[3] <=  100){h=32;
    }else {errFlg=true;}

    //横幅W
		ww=String(dataInfo[1]);
		if(30 <= dataInfo[1] && dataInfo[1] <=  150){
			if(ww.slice(-1)>=1 && ww.slice(-1)<=4){w=parseInt(ww.slice(0,ww.length-1)) +"5";
			ww=(Math.floor(w/5))-6;}
			else if (ww.slice(-1)>=6 && ww.slice(-1)<=9){w=parseInt(ww.slice(0,ww.length-1)) + 1 +"0";
			ww=(Math.floor(w/5))-6;}
			else if(ww.slice(-1)=="0" | ww.slice(-1)=="5"){ww=(Math.floor(dataInfo[1]/5))-6;
    			}else {errFlg=true;}
		}else {errFlg=true;}
        //奥行D
		dd=String(dataInfo[2]);
		if(15 <= dataInfo[2] && dataInfo[2] <=  90){
			if(dd.slice(-1)>=1 && dd.slice(-1)<=4){d=parseInt(dd.slice(0,dd.length-1)) +"5";
			dd=(Math.floor(d/5))-3;}
			else if (dd.slice(-1)>=6 && dd.slice(-1)<=9){d=parseInt(dd.slice(0,dd.length-1)) + 1 +"0";
			dd=(Math.floor(d/5))-3;}
			else if(dd.slice(-1)=="0" | dd.slice(-1)=="5"){dd=(Math.floor(dataInfo[2]/5))-3;
    			}else {errFlg=true;}
		}else {errFlg=true;}
/*下一桁1～4切り上げの為削除予定
    if(30 <= dataInfo[1] && dataInfo[1] <=  150){w=(Math.floor(dataInfo[1]/5))-6;
    }else {errFlg=true;}
    
    //奥行D
    if(15 <= dataInfo[2] && dataInfo[2] <=  90){d=(Math.floor(dataInfo[2]/5))-3;
    }else {errFlg=true;}
*/
    tmp = h + dd;
//    console.log("2:"+tmp+ "/" +w);
    if(!errFlg){
      price=priceList[tmp][ww];//価格表照会
      switch(dataInfo[5]){//幕板サイズ加算
        case 1:price = Math.ceil( price * 1.05 /100)*100;break;
        case 2:price = Math.ceil( price * 1.15 /100)*100;break;
      }
	}
    }
    
    
//化粧紙・メラミン共通幕板ロングYHC価格
var idx = $('#mak_size option:selected').index();
if(90 <= dataInfo[3] && dataInfo[3] <=  100){
      switch(idx){
        case 0:break;
        case 1:break;
        case 2:if(idx == 2){price = price + 3500;}break;
      }
}

	  
      $(opInfo).each(function(i){//オプション加算
        switch(i){
          case 0:
          case 1:if(opInfo[i]){price=Number(price)+1000;}break;
          case 2:
          case 3:
          case 4:if(opInfo[i]){price=Number(price)+1500;}break;
        }
      });
      $("#price").val(new Intl.NumberFormat().format(price) + " 円");
      $("#cart_price").text(new Intl.NumberFormat().format(price) + " 円");
//      console.log(price);
    return price;//価格
  }
  
  // 既存製品確認処理
  function checkItemList(){
    var tmp;
    var url="";
	var checkH;
	var checkM;
	var checkCt;
	var checkCl;
	var checkCm;
	var checkColor;
	var checkHm;
	var kizonFlg = false;


	checkH = dataInfo[3];
	checkM = dataInfo[5];
	checkCt = dataInfo[6];
	checkCl = dataInfo[7];
	checkCm = dataInfo[8];
	checkHm = $("#step7 input:checked").val()

//板種類
//0：木目 1：aino 2：nail 3：BP 4：GS 5：MB 6：WW 7：black
    if(checkCt == checkCl){
		if(checkCt <= 7 && checkCm <= 7){
			if(checkCt <= 7){checkColor=0;}
		}
        else if(checkCt >= 8 && checkCt <= 13 && checkCm >= 8 && checkCm <= 13){checkColor=1;}
        else if(checkCt==14){checkColor=2;}
        else if(checkCt==15){checkColor=3;}
        else if(checkCt==16){checkColor=4;}
        else if(checkCt==17){checkColor=5;}
        else if(checkCt==18){checkColor=6;}
        else if(checkCt==19){checkColor=7;}
    }

    if(opInfo.indexOf(1) === -1){
      $(itemList).each(function(i){
        tmp = itemList[i];
        if( tmp[0] == dataInfo[1] && tmp[1] == dataInfo[2]
         && tmp[2] == dataInfo[3] && tmp[3] == dataInfo[0] && tmp[4] == checkColor){
         url = strLink1+tmp[5];
         return false;
        }
      });
      if(url!="" && checkM == 0 && checkCt == checkCl && 89 > checkH){
        $("#linkmsg").find("a").attr("href",url);
        $("#linkmsg").show();
        $("#price").val('');//空欄
        $("#cart_price").text('');//空欄
		if(checkHm == "不要"){alert("既製品ページからご注文をお願いします。\nご注文時備考欄に「ハンマー不要」と記入ください");}
		return kizonFlg = true;
      }else if(url!="" && checkM == 1 && checkCt == checkCl && 90 <= checkH){
        $("#linkmsg").find("a").attr("href",url);
        $("#linkmsg").show();
        $("#price").val('');//空欄
        $("#cart_price").text('');//空欄
		if(checkHm == "不要"){alert("既製品ページからご注文をお願いします。\nご注文時備考欄に「ハンマー不要」と記入ください");}
		return kizonFlg = true;
			   }
    }
return kizonFlg = false;
  }
  
  function jump(){
    var sizemsg = "";
    var op_positionL = $("#op_positionL").val();
    var op_positionU = $("#op_positionU").val();
    var op_positionS = $("#hole_ichi").val();
    $(sizeFlg).each(function(i){
      switch(i){
        case 0:if(!sizeFlg[i]){sizemsg+="幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。\n"};
        break;
        case 1:if(!sizeFlg[i]){sizemsg+="奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください\n"};
        break;
        case 2:if(!sizeFlg[i]){sizemsg+="高さは『1以上の整数(小数点不可/半角文字）』をご入力ください"};
        break;
        case 3:if(!sizeFlg[i]){sizemsg+="高さ90cm以上の場合、ショート選択できません "};
        break;
        case 4:if(!sizeFlg[i]){sizemsg+="台形脚選択の場合、奥行30cm未満はオーダー不可です"};
        break;
      }
    });
    $(colorFlg).each(function(i){
      if(!colorFlg[i]){
        if(!(sizemsg=="")){
          sizemsg+="\n";
        }
        sizemsg+="カラーを選択してください";
        return false;
      }
    });


//配線穴位置確認
    if($("#op_concent").prop("checked") == true){
    if(op_positionS=="穴位置を選択してください"){
      alert("配線穴の位置を入力してください");
      return false;
    }
}
/*
    if($("#op_concent").prop("checked") == true){
    if(op_positionL==""|op_positionU==""){
      alert("配線穴の位置を入力してください");
      return false;
    }
}
*/
    if(!(sizemsg=="")){
      alert(sizemsg);
      checkTextFlg = false;
      return false;
    }
    var color = ["ブラウン","ダークブラウン","チーク","ナチュラル","ホワイトウッド","ホワイト","オーク","ブラックウッド","ainoピンク","ainoオレンジ","ainoイエロー","ainoグリーン","ainoブルー","ainoグレー","NAIL","BP","GS","MB","WW","BLACK"];
    var mak = ["ショート","ハーフ","ロング"];
    var leg = ["ストレート","台形"];
    var ichi = ["背面","中央"];
    var option = ["配線切り欠き","配線穴","キャスター(ブラック)","キャスター(ホワイト)"];
    var price = 0;
    var opstr = "";
    var total = 0;
    var check;

    $(opInfo).each(function(i){
      if(opInfo[i]==1){
        if(!(opstr=="")){opstr+="、";}
        if(option[i]==option[1]){check="ana";anaCK();opstr += "配線穴"+panel_ichi;}
        else{opstr += option[i];}
        if(option[i]==option[0]||option[i]==option[1]){total=total+1000;}
        else if(option[i]==option[2]||option[i]==option[3]){total=total+1500;}
      }
    });
    if(opstr==""){opstr+="オプション無し";}

//配線穴の位置追加
function anaCK(){
var haisenCK="ana";
if(check==haisenCK){
      checkBoxhaisen = $("input[name='op_panel']:checked").val();
      op_position = "";

  switch(checkBoxhaisen){
    case "panel_a":
	op_position = "幕板";
	break;
    case "panel_b":
	op_position = "左側板";
	break;
    case "panel_c":
	op_position = "右側板";
	break;
    case "panel_d":
	op_position = "天板";
	break;
  }
  panel_ichi = "("+op_position+"の"+op_positionS+"に配線穴中央が来る配置)";
}
}

    //表示項目埋め込み
    var result =$("#check_list").find(".result");
    result.eq(0).text(dataInfo[1]);
    result.eq(1).text(dataInfo[2]);
    result.eq(2).text(dataInfo[3]);
    result.eq(3).text(ichi[dataInfo[4]]);
    result.eq(4).text(mak[dataInfo[5]]);
    result.eq(5).text(leg[dataInfo[0]]);
    result.eq(6).text(color[dataInfo[6]]);
    result.eq(7).text(color[dataInfo[7]]);
    result.eq(8).text(color[dataInfo[8]]);
    result.eq(9).text(opstr);
    result.eq(10).text($("#step7 input:checked").val());
    result.eq(11).text(total);
    price = calcPrice();//料金計算 ※[units]のみ中で設定
    kizonFlg = checkItemList();//既製品チェック
    

    $("#choice1").val(dataInfo[1] + "cm");
    $("#choice2").val(dataInfo[2] + "cm");
    $("#choice3").val(dataInfo[3] + "cm");
    $("#choice4").val(ichi[dataInfo[4]]);
    $("#choice5").val(mak[dataInfo[5]]);
    $("#choice6").val(leg[dataInfo[0]]);
    $("#choice7").val(color[dataInfo[6]]);
    $("#choice8").val(color[dataInfo[7]]);
    $("#choice9").val(color[dataInfo[8]]);
    $("#choice10").val(opstr);
    $("#choice11").val($("#step7 input:checked").val());
    $("#choice13").val("追加金額：" + total);
    $("#choice12").val("見積もり金額：" + price);
    $("#units").val(price / 100 );
	if(kizonFlg == false){checkTextFlg = true;}
  }


  var itemList = [//既製品一覧　カラー：木目0、aino1、nail2、BP3、GS4、MB5、WW6、BLACK7
    [110, 75,  72, 1, 0, "0000ae000541"],
    [ 90, 60,  72, 1, 0, "0000ae000549"],
    [110, 40,  78, 0, 0, "0000ae000557"],
    [110, 45, 100, 0, 0, "0000ae000565"],
    [110, 60,  78, 0, 0, "0000ae000573"],
    [110, 75,  72, 0, 0, "0000ae000581"],
    [ 30, 30,  65, 0, 0, "0000ae000589"],
    [ 38, 38,  45, 0, 0, "0000ae000597"],
    [ 90, 30,  65, 0, 0, "0000ae000605"],
    [ 90, 38,  45, 0, 0, "0000ae000613"],
    [ 90, 40,  78, 0, 0, "0000ae000621"],
    [ 90, 45, 100, 0, 0, "0000ae000629"],
    [ 90, 60,  72, 0, 0, "0000ae000637"],
    [ 90, 60,  78, 0, 0, "0000ae000645"],
	[110,75,72,1,1,"0000ae000653"],
	[90,60,72,1,1,"0000ae000659"],
	[110,40,78,0,1,"0000ae000665"],
	[110,45,100,0,1,"0000ae000671"],
	[110,60,78,0,1,"0000ae000677"],
	[110,75,72,0,1,"0000ae000683"],
	[30,30,65,0,1,"0000ae000689"],
	[38,38,45,0,1,"0000ae000695"],
	[90,30,65,0,1,"0000ae000701"],
	[90,38,45,0,1,"0000ae000707"],
	[90,40,78,0,1,"0000ae000713"],
	[90,45,100,0,1,"0000ae000719"],
	[90,60,72,0,1,"0000ae000725"],
	[90,60,78,0,1,"0000ae000731"],
	[110,75,72,1,2,"0000ae000761"],
	[110,75,72,1,7,"0000ae000762"],
	[110,75,72,1,3,"0000ae000763"],
	[110,75,72,1,5,"0000ae000764"],
	[110,75,72,1,4,"0000ae000765"],
	[110,75,72,1,6,"0000ae000766"],
	[90,60,72,1,2,"0000ae000767"],
	[90,60,72,1,7,"0000ae000768"],
	[90,60,72,1,3,"0000ae000769"],
	[90,60,72,1,5,"0000ae000770"],
	[90,60,72,1,4,"0000ae000771"],
	[90,60,72,1,6,"0000ae000772"],
	[110,40,78,0,2,"0000ae000773"],
	[110,40,78,0,7,"0000ae000774"],
	[110,40,78,0,3,"0000ae000775"],
	[110,40,78,0,5,"0000ae000776"],
	[110,40,78,0,4,"0000ae000777"],
	[110,40,78,0,6,"0000ae000778"],
	[110,45,100,0,2,"0000ae000779"],
	[110,45,100,0,7,"0000ae000780"],
	[110,45,100,0,3,"0000ae000781"],
	[110,45,100,0,5,"0000ae000782"],
	[110,45,100,0,4,"0000ae000783"],
	[110,45,100,0,6,"0000ae000784"],
	[110,60,78,0,2,"0000ae000785"],
	[110,60,78,0,7,"0000ae000786"],
	[110,60,78,0,3,"0000ae000787"],
	[110,60,78,0,5,"0000ae000788"],
	[110,60,78,0,4,"0000ae000789"],
	[110,60,78,0,6,"0000ae000790"],
	[110,75,72,0,2,"0000ae000791"],
	[110,75,72,0,7,"0000ae000792"],
	[110,75,72,0,3,"0000ae000793"],
	[110,75,72,0,5,"0000ae000794"],
	[110,75,72,0,4,"0000ae000795"],
	[110,75,72,0,6,"0000ae000796"],
	[30,30,65,0,2,"0000ae000797"],
	[30,30,65,0,7,"0000ae000798"],
	[30,30,65,0,3,"0000ae000799"],
	[30,30,65,0,5,"0000ae000800"],
	[30,30,65,0,4,"0000ae000801"],
	[30,30,65,0,6,"0000ae000802"],
	[38,38,45,0,2,"0000ae000803"],
	[38,38,45,0,7,"0000ae000804"],
	[38,38,45,0,3,"0000ae000805"],
	[38,38,45,0,5,"0000ae000806"],
	[38,38,45,0,4,"0000ae000807"],
	[38,38,45,0,6,"0000ae000808"],
	[90,30,65,0,2,"0000ae000809"],
	[90,30,65,0,7,"0000ae000810"],
	[90,30,65,0,3,"0000ae000811"],
	[90,30,65,0,5,"0000ae000812"],
	[90,30,65,0,4,"0000ae000813"],
	[90,30,65,0,6,"0000ae000814"],
	[90,38,45,0,2,"0000ae000815"],
	[90,38,45,0,7,"0000ae000816"],
	[90,38,45,0,3,"0000ae000817"],
	[90,38,45,0,5,"0000ae000818"],
	[90,38,45,0,4,"0000ae000819"],
	[90,38,45,0,6,"0000ae000820"],
	[90,40,78,0,2,"0000ae000821"],
	[90,40,78,0,7,"0000ae000822"],
	[90,40,78,0,3,"0000ae000823"],
	[90,40,78,0,5,"0000ae000824"],
	[90,40,78,0,4,"0000ae000825"],
	[90,40,78,0,6,"0000ae000826"],
	[90,45,100,0,2,"0000ae000827"],
	[90,45,100,0,7,"0000ae000828"],
	[90,45,100,0,3,"0000ae000829"],
	[90,45,100,0,5,"0000ae000830"],
	[90,45,100,0,4,"0000ae000831"],
	[90,45,100,0,6,"0000ae000832"],
	[90,60,72,0,2,"0000ae000833"],
	[90,60,72,0,7,"0000ae000834"],
	[90,60,72,0,3,"0000ae000835"],
	[90,60,72,0,5,"0000ae000836"],
	[90,60,72,0,4,"0000ae000837"],
	[90,60,72,0,6,"0000ae000838"],
	[90,60,78,0,2,"0000ae000839"],
	[90,60,78,0,7,"0000ae000840"],
	[90,60,78,0,3,"0000ae000841"],
	[90,60,78,0,5,"0000ae000842"],
	[90,60,78,0,4,"0000ae000843"],
	[90,60,78,0,6,"0000ae000844"],
	[30,20,40,0,0,"0000ae000845"],
	[40,20,40,0,0,"0000ae000853"],
	[50,20,40,0,0,"0000ae000861"],
	[60,20,40,0,0,"0000ae000869"],
	[70,20,40,0,0,"0000ae000877"],
	[80,20,40,0,0,"0000ae000885"],
	[90,20,40,0,0,"0000ae000893"],
	[100,20,40,0,0,"0000ae000901"],
	[110,20,40,0,0,"0000ae000909"],
	[120,20,40,0,0,"0000ae000917"],
	[130,20,40,0,0,"0000ae000925"],
	[140,20,40,0,0,"0000ae000933"],
	[150,20,40,0,0,"0000ae000941"],
	[30,30,40,0,0,"0000ae000949"],
	[40,30,40,0,0,"0000ae000957"],
	[50,30,40,0,0,"0000ae000965"],
	[60,30,40,0,0,"0000ae000973"],
	[70,30,40,0,0,"0000ae000981"],
	[80,30,40,0,0,"0000ae000989"],
	[90,30,40,0,0,"0000ae000997"],
	[100,30,40,0,0,"0000ae001005"],
	[110,30,40,0,0,"0000ae001013"],
	[120,30,40,0,0,"0000ae001021"],
	[130,30,40,0,0,"0000ae001029"],
	[140,30,40,0,0,"0000ae001037"],
	[150,30,40,0,0,"0000ae001045"],
	[30,40,40,0,0,"0000ae001053"],
	[40,40,40,0,0,"0000ae001061"],
	[50,40,40,0,0,"0000ae001069"],
	[60,40,40,0,0,"0000ae001077"],
	[70,40,40,0,0,"0000ae001085"],
	[80,40,40,0,0,"0000ae001093"],
	[90,40,40,0,0,"0000ae001101"],
	[100,40,40,0,0,"0000ae001109"],
	[110,40,40,0,0,"0000ae001117"],
	[120,40,40,0,0,"0000ae001125"],
	[130,40,40,0,0,"0000ae001133"],
	[140,40,40,0,0,"0000ae001141"],
	[150,40,40,0,0,"0000ae001149"],
	[30,50,40,0,0,"0000ae001157"],
	[40,50,40,0,0,"0000ae001165"],
	[50,50,40,0,0,"0000ae001173"],
	[60,50,40,0,0,"0000ae001181"],
	[70,50,40,0,0,"0000ae001189"],
	[80,50,40,0,0,"0000ae001197"],
	[90,50,40,0,0,"0000ae001205"],
	[100,50,40,0,0,"0000ae001213"],
	[110,50,40,0,0,"0000ae001221"],
	[120,50,40,0,0,"0000ae001229"],
	[130,50,40,0,0,"0000ae001237"],
	[140,50,40,0,0,"0000ae001245"],
	[150,50,40,0,0,"0000ae001253"],
	[30,60,40,0,0,"0000ae001261"],
	[40,60,40,0,0,"0000ae001269"],
	[50,60,40,0,0,"0000ae001277"],
	[60,60,40,0,0,"0000ae001285"],
	[70,60,40,0,0,"0000ae001293"],
	[80,60,40,0,0,"0000ae001301"],
	[90,60,40,0,0,"0000ae001309"],
	[100,60,40,0,0,"0000ae001317"],
	[110,60,40,0,0,"0000ae001325"],
	[120,60,40,0,0,"0000ae001333"],
	[130,60,40,0,0,"0000ae001341"],
	[140,60,40,0,0,"0000ae001349"],
	[150,60,40,0,0,"0000ae001357"],
	[30,70,40,0,0,"0000ae001365"],
	[40,70,40,0,0,"0000ae001373"],
	[50,70,40,0,0,"0000ae001381"],
	[60,70,40,0,0,"0000ae001389"],
	[70,70,40,0,0,"0000ae001397"],
	[80,70,40,0,0,"0000ae001405"],
	[90,70,40,0,0,"0000ae001413"],
	[100,70,40,0,0,"0000ae001421"],
	[110,70,40,0,0,"0000ae001429"],
	[120,70,40,0,0,"0000ae001437"],
	[130,70,40,0,0,"0000ae001445"],
	[140,70,40,0,0,"0000ae001453"],
	[150,70,40,0,0,"0000ae001461"],
	[30,80,40,0,0,"0000ae001469"],
	[40,80,40,0,0,"0000ae001477"],
	[50,80,40,0,0,"0000ae001485"],
	[60,80,40,0,0,"0000ae001493"],
	[70,80,40,0,0,"0000ae001501"],
	[80,80,40,0,0,"0000ae001509"],
	[90,80,40,0,0,"0000ae001517"],
	[100,80,40,0,0,"0000ae001525"],
	[110,80,40,0,0,"0000ae001533"],
	[120,80,40,0,0,"0000ae001541"],
	[130,80,40,0,0,"0000ae001549"],
	[140,80,40,0,0,"0000ae001557"],
	[150,80,40,0,0,"0000ae001565"],
	[30,90,40,0,0,"0000ae001573"],
	[40,90,40,0,0,"0000ae001581"],
	[50,90,40,0,0,"0000ae001589"],
	[60,90,40,0,0,"0000ae001597"],
	[70,90,40,0,0,"0000ae001605"],
	[80,90,40,0,0,"0000ae001613"],
	[90,90,40,0,0,"0000ae001621"],
	[100,90,40,0,0,"0000ae001629"],
	[110,90,40,0,0,"0000ae001637"],
	[120,90,40,0,0,"0000ae001645"],
	[130,90,40,0,0,"0000ae001653"],
	[140,90,40,0,0,"0000ae001661"],
	[150,90,40,0,0,"0000ae001669"],
	[30,20,50,0,0,"0000ae001677"],
	[40,20,50,0,0,"0000ae001685"],
	[50,20,50,0,0,"0000ae001693"],
	[60,20,50,0,0,"0000ae001701"],
	[70,20,50,0,0,"0000ae001709"],
	[80,20,50,0,0,"0000ae001717"],
	[90,20,50,0,0,"0000ae001725"],
	[100,20,50,0,0,"0000ae001733"],
	[110,20,50,0,0,"0000ae001741"],
	[120,20,50,0,0,"0000ae001749"],
	[130,20,50,0,0,"0000ae001757"],
	[140,20,50,0,0,"0000ae001765"],
	[150,20,50,0,0,"0000ae001773"],
	[30,30,50,0,0,"0000ae001781"],
	[40,30,50,0,0,"0000ae001789"],
	[50,30,50,0,0,"0000ae001797"],
	[60,30,50,0,0,"0000ae001805"],
	[70,30,50,0,0,"0000ae001813"],
	[80,30,50,0,0,"0000ae001821"],
	[90,30,50,0,0,"0000ae001829"],
	[100,30,50,0,0,"0000ae001837"],
	[110,30,50,0,0,"0000ae001845"],
	[120,30,50,0,0,"0000ae001853"],
	[130,30,50,0,0,"0000ae001861"],
	[140,30,50,0,0,"0000ae001869"],
	[150,30,50,0,0,"0000ae001877"],
	[30,40,50,0,0,"0000ae001885"],
	[40,40,50,0,0,"0000ae001893"],
	[50,40,50,0,0,"0000ae001901"],
	[60,40,50,0,0,"0000ae001909"],
	[70,40,50,0,0,"0000ae001917"],
	[80,40,50,0,0,"0000ae001925"],
	[90,40,50,0,0,"0000ae001933"],
	[100,40,50,0,0,"0000ae001941"],
	[110,40,50,0,0,"0000ae001949"],
	[120,40,50,0,0,"0000ae001957"],
	[130,40,50,0,0,"0000ae001965"],
	[140,40,50,0,0,"0000ae001973"],
	[150,40,50,0,0,"0000ae001981"],
	[30,50,50,0,0,"0000ae001989"],
	[40,50,50,0,0,"0000ae001997"],
	[50,50,50,0,0,"0000ae002005"],
	[60,50,50,0,0,"0000ae002013"],
	[70,50,50,0,0,"0000ae002021"],
	[80,50,50,0,0,"0000ae002029"],
	[90,50,50,0,0,"0000ae002037"],
	[100,50,50,0,0,"0000ae002045"],
	[110,50,50,0,0,"0000ae002053"],
	[120,50,50,0,0,"0000ae002061"],
	[130,50,50,0,0,"0000ae002069"],
	[140,50,50,0,0,"0000ae002077"],
	[150,50,50,0,0,"0000ae002085"],
	[30,60,50,0,0,"0000ae002093"],
	[40,60,50,0,0,"0000ae002101"],
	[50,60,50,0,0,"0000ae002109"],
	[60,60,50,0,0,"0000ae002117"],
	[70,60,50,0,0,"0000ae002125"],
	[80,60,50,0,0,"0000ae002133"],
	[90,60,50,0,0,"0000ae002141"],
	[100,60,50,0,0,"0000ae002149"],
	[110,60,50,0,0,"0000ae002157"],
	[120,60,50,0,0,"0000ae002165"],
	[130,60,50,0,0,"0000ae002173"],
	[140,60,50,0,0,"0000ae002181"],
	[150,60,50,0,0,"0000ae002189"],
	[30,70,50,0,0,"0000ae002197"],
	[40,70,50,0,0,"0000ae002205"],
	[50,70,50,0,0,"0000ae002213"],
	[60,70,50,0,0,"0000ae002221"],
	[70,70,50,0,0,"0000ae002229"],
	[80,70,50,0,0,"0000ae002237"],
	[90,70,50,0,0,"0000ae002245"],
	[100,70,50,0,0,"0000ae002253"],
	[110,70,50,0,0,"0000ae002261"],
	[120,70,50,0,0,"0000ae002269"],
	[130,70,50,0,0,"0000ae002277"],
	[140,70,50,0,0,"0000ae002285"],
	[150,70,50,0,0,"0000ae002293"],
	[30,80,50,0,0,"0000ae002301"],
	[40,80,50,0,0,"0000ae002309"],
	[50,80,50,0,0,"0000ae002317"],
	[60,80,50,0,0,"0000ae002325"],
	[70,80,50,0,0,"0000ae002333"],
	[80,80,50,0,0,"0000ae002341"],
	[90,80,50,0,0,"0000ae002349"],
	[100,80,50,0,0,"0000ae002357"],
	[110,80,50,0,0,"0000ae002365"],
	[120,80,50,0,0,"0000ae002373"],
	[130,80,50,0,0,"0000ae002381"],
	[140,80,50,0,0,"0000ae002389"],
	[150,80,50,0,0,"0000ae002397"],
	[30,90,50,0,0,"0000ae002405"],
	[40,90,50,0,0,"0000ae002413"],
	[50,90,50,0,0,"0000ae002421"],
	[60,90,50,0,0,"0000ae002429"],
	[70,90,50,0,0,"0000ae002437"],
	[80,90,50,0,0,"0000ae002445"],
	[90,90,50,0,0,"0000ae002453"],
	[100,90,50,0,0,"0000ae002461"],
	[110,90,50,0,0,"0000ae002469"],
	[120,90,50,0,0,"0000ae002477"],
	[130,90,50,0,0,"0000ae002485"],
	[140,90,50,0,0,"0000ae002493"],
	[150,90,50,0,0,"0000ae002501"],
	[30,20,60,0,0,"0000ae002509"],
	[40,20,60,0,0,"0000ae002517"],
	[50,20,60,0,0,"0000ae002525"],
	[60,20,60,0,0,"0000ae002533"],
	[70,20,60,0,0,"0000ae002541"],
	[80,20,60,0,0,"0000ae002549"],
	[90,20,60,0,0,"0000ae002557"],
	[100,20,60,0,0,"0000ae002565"],
	[110,20,60,0,0,"0000ae002573"],
	[120,20,60,0,0,"0000ae002581"],
	[130,20,60,0,0,"0000ae002589"],
	[140,20,60,0,0,"0000ae002597"],
	[150,20,60,0,0,"0000ae002605"],
	[30,30,60,0,0,"0000ae002613"],
	[40,30,60,0,0,"0000ae002621"],
	[50,30,60,0,0,"0000ae002629"],
	[60,30,60,0,0,"0000ae002637"],
	[70,30,60,0,0,"0000ae002645"],
	[80,30,60,0,0,"0000ae002653"],
	[90,30,60,0,0,"0000ae002661"],
	[100,30,60,0,0,"0000ae002669"],
	[110,30,60,0,0,"0000ae002677"],
	[120,30,60,0,0,"0000ae002685"],
	[130,30,60,0,0,"0000ae002693"],
	[140,30,60,0,0,"0000ae002701"],
	[150,30,60,0,0,"0000ae002709"],
	[30,40,60,0,0,"0000ae002717"],
	[40,40,60,0,0,"0000ae002725"],
	[50,40,60,0,0,"0000ae002733"],
	[60,40,60,0,0,"0000ae002741"],
	[70,40,60,0,0,"0000ae002749"],
	[80,40,60,0,0,"0000ae002757"],
	[90,40,60,0,0,"0000ae002765"],
	[100,40,60,0,0,"0000ae002773"],
	[110,40,60,0,0,"0000ae002781"],
	[120,40,60,0,0,"0000ae002789"],
	[130,40,60,0,0,"0000ae002797"],
	[140,40,60,0,0,"0000ae002805"],
	[150,40,60,0,0,"0000ae002813"],
	[30,50,60,0,0,"0000ae002821"],
	[40,50,60,0,0,"0000ae002829"],
	[50,50,60,0,0,"0000ae002837"],
	[60,50,60,0,0,"0000ae002845"],
	[70,50,60,0,0,"0000ae002853"],
	[80,50,60,0,0,"0000ae002861"],
	[90,50,60,0,0,"0000ae002869"],
	[100,50,60,0,0,"0000ae002877"],
	[110,50,60,0,0,"0000ae002885"],
	[120,50,60,0,0,"0000ae002893"],
	[130,50,60,0,0,"0000ae002901"],
	[140,50,60,0,0,"0000ae002909"],
	[150,50,60,0,0,"0000ae002917"],
	[30,60,60,0,0,"0000ae002925"],
	[40,60,60,0,0,"0000ae002933"],
	[50,60,60,0,0,"0000ae002941"],
	[60,60,60,0,0,"0000ae002949"],
	[70,60,60,0,0,"0000ae002957"],
	[80,60,60,0,0,"0000ae002965"],
	[90,60,60,0,0,"0000ae002973"],
	[100,60,60,0,0,"0000ae002981"],
	[110,60,60,0,0,"0000ae002989"],
	[120,60,60,0,0,"0000ae002997"],
	[130,60,60,0,0,"0000ae003005"],
	[140,60,60,0,0,"0000ae003013"],
	[150,60,60,0,0,"0000ae003021"],
	[30,70,60,0,0,"0000ae003029"],
	[40,70,60,0,0,"0000ae003037"],
	[50,70,60,0,0,"0000ae003045"],
	[60,70,60,0,0,"0000ae003053"],
	[70,70,60,0,0,"0000ae003061"],
	[80,70,60,0,0,"0000ae003069"],
	[90,70,60,0,0,"0000ae003077"],
	[100,70,60,0,0,"0000ae003085"],
	[110,70,60,0,0,"0000ae003093"],
	[120,70,60,0,0,"0000ae003101"],
	[130,70,60,0,0,"0000ae003109"],
	[140,70,60,0,0,"0000ae003117"],
	[150,70,60,0,0,"0000ae003125"],
	[30,80,60,0,0,"0000ae003133"],
	[40,80,60,0,0,"0000ae003141"],
	[50,80,60,0,0,"0000ae003149"],
	[60,80,60,0,0,"0000ae003157"],
	[70,80,60,0,0,"0000ae003165"],
	[80,80,60,0,0,"0000ae003173"],
	[90,80,60,0,0,"0000ae003181"],
	[100,80,60,0,0,"0000ae003189"],
	[110,80,60,0,0,"0000ae003197"],
	[120,80,60,0,0,"0000ae003205"],
	[130,80,60,0,0,"0000ae003213"],
	[140,80,60,0,0,"0000ae003221"],
	[150,80,60,0,0,"0000ae003229"],
	[30,90,60,0,0,"0000ae003237"],
	[40,90,60,0,0,"0000ae003245"],
	[50,90,60,0,0,"0000ae003253"],
	[60,90,60,0,0,"0000ae003261"],
	[70,90,60,0,0,"0000ae003269"],
	[80,90,60,0,0,"0000ae003277"],
	[90,90,60,0,0,"0000ae003285"],
	[100,90,60,0,0,"0000ae003293"],
	[110,90,60,0,0,"0000ae003301"],
	[120,90,60,0,0,"0000ae003309"],
	[130,90,60,0,0,"0000ae003317"],
	[140,90,60,0,0,"0000ae003325"],
	[150,90,60,0,0,"0000ae003333"],
	[30,20,70,0,0,"0000ae003341"],
	[40,20,70,0,0,"0000ae003349"],
	[50,20,70,0,0,"0000ae003357"],
	[60,20,70,0,0,"0000ae003365"],
	[70,20,70,0,0,"0000ae003373"],
	[80,20,70,0,0,"0000ae003381"],
	[90,20,70,0,0,"0000ae003389"],
	[100,20,70,0,0,"0000ae003397"],
	[110,20,70,0,0,"0000ae003405"],
	[120,20,70,0,0,"0000ae003413"],
	[130,20,70,0,0,"0000ae003421"],
	[140,20,70,0,0,"0000ae003429"],
	[150,20,70,0,0,"0000ae003437"],
	[30,30,70,0,0,"0000ae003445"],
	[40,30,70,0,0,"0000ae003453"],
	[50,30,70,0,0,"0000ae003461"],
	[60,30,70,0,0,"0000ae003469"],
	[70,30,70,0,0,"0000ae003477"],
	[80,30,70,0,0,"0000ae003485"],
	[90,30,70,0,0,"0000ae003493"],
	[100,30,70,0,0,"0000ae003501"],
	[110,30,70,0,0,"0000ae003509"],
	[120,30,70,0,0,"0000ae003517"],
	[130,30,70,0,0,"0000ae003525"],
	[140,30,70,0,0,"0000ae003533"],
	[150,30,70,0,0,"0000ae003541"],
	[30,40,70,0,0,"0000ae003549"],
	[40,40,70,0,0,"0000ae003557"],
	[50,40,70,0,0,"0000ae003565"],
	[60,40,70,0,0,"0000ae003573"],
	[70,40,70,0,0,"0000ae003581"],
	[80,40,70,0,0,"0000ae003589"],
	[90,40,70,0,0,"0000ae003597"],
	[100,40,70,0,0,"0000ae003605"],
	[110,40,70,0,0,"0000ae003613"],
	[120,40,70,0,0,"0000ae003621"],
	[130,40,70,0,0,"0000ae003629"],
	[140,40,70,0,0,"0000ae003637"],
	[150,40,70,0,0,"0000ae003645"],
	[30,50,70,0,0,"0000ae003653"],
	[40,50,70,0,0,"0000ae003661"],
	[50,50,70,0,0,"0000ae003669"],
	[60,50,70,0,0,"0000ae003677"],
	[70,50,70,0,0,"0000ae003685"],
	[80,50,70,0,0,"0000ae003693"],
	[90,50,70,0,0,"0000ae003701"],
	[100,50,70,0,0,"0000ae003709"],
	[110,50,70,0,0,"0000ae003717"],
	[120,50,70,0,0,"0000ae003725"],
	[130,50,70,0,0,"0000ae003733"],
	[140,50,70,0,0,"0000ae003741"],
	[150,50,70,0,0,"0000ae003749"],
	[30,60,70,0,0,"0000ae003757"],
	[40,60,70,0,0,"0000ae003765"],
	[50,60,70,0,0,"0000ae003773"],
	[60,60,70,0,0,"0000ae003781"],
	[70,60,70,0,0,"0000ae003789"],
	[80,60,70,0,0,"0000ae003797"],
	[90,60,70,0,0,"0000ae003805"],
	[100,60,70,0,0,"0000ae003813"],
	[110,60,70,0,0,"0000ae003821"],
	[120,60,70,0,0,"0000ae003829"],
	[130,60,70,0,0,"0000ae003837"],
	[140,60,70,0,0,"0000ae003845"],
	[150,60,70,0,0,"0000ae003853"],
	[30,70,70,0,0,"0000ae003861"],
	[40,70,70,0,0,"0000ae003869"],
	[50,70,70,0,0,"0000ae003877"],
	[60,70,70,0,0,"0000ae003885"],
	[70,70,70,0,0,"0000ae003893"],
	[80,70,70,0,0,"0000ae003901"],
	[90,70,70,0,0,"0000ae003909"],
	[100,70,70,0,0,"0000ae003917"],
	[110,70,70,0,0,"0000ae003925"],
	[120,70,70,0,0,"0000ae003933"],
	[130,70,70,0,0,"0000ae003941"],
	[140,70,70,0,0,"0000ae003949"],
	[150,70,70,0,0,"0000ae003957"],
	[30,80,70,0,0,"0000ae003965"],
	[40,80,70,0,0,"0000ae003973"],
	[50,80,70,0,0,"0000ae003981"],
	[60,80,70,0,0,"0000ae003989"],
	[70,80,70,0,0,"0000ae003997"],
	[80,80,70,0,0,"0000ae004005"],
	[90,80,70,0,0,"0000ae004013"],
	[100,80,70,0,0,"0000ae004021"],
	[110,80,70,0,0,"0000ae004029"],
	[120,80,70,0,0,"0000ae004037"],
	[130,80,70,0,0,"0000ae004045"],
	[140,80,70,0,0,"0000ae004053"],
	[150,80,70,0,0,"0000ae004061"],
	[30,90,70,0,0,"0000ae004069"],
	[40,90,70,0,0,"0000ae004077"],
	[50,90,70,0,0,"0000ae004085"],
	[60,90,70,0,0,"0000ae004093"],
	[70,90,70,0,0,"0000ae004101"],
	[80,90,70,0,0,"0000ae004109"],
	[90,90,70,0,0,"0000ae004117"],
	[100,90,70,0,0,"0000ae004125"],
	[110,90,70,0,0,"0000ae004133"],
	[120,90,70,0,0,"0000ae004141"],
	[130,90,70,0,0,"0000ae004149"],
	[140,90,70,0,0,"0000ae004157"],
	[150,90,70,0,0,"0000ae004165"],
	[30,20,80,0,0,"0000ae004173"],
	[40,20,80,0,0,"0000ae004181"],
	[50,20,80,0,0,"0000ae004189"],
	[60,20,80,0,0,"0000ae004197"],
	[70,20,80,0,0,"0000ae004205"],
	[80,20,80,0,0,"0000ae004213"],
	[90,20,80,0,0,"0000ae004221"],
	[100,20,80,0,0,"0000ae004229"],
	[110,20,80,0,0,"0000ae004237"],
	[120,20,80,0,0,"0000ae004245"],
	[130,20,80,0,0,"0000ae004253"],
	[140,20,80,0,0,"0000ae004261"],
	[150,20,80,0,0,"0000ae004269"],
	[30,30,80,0,0,"0000ae004277"],
	[40,30,80,0,0,"0000ae004285"],
	[50,30,80,0,0,"0000ae004293"],
	[60,30,80,0,0,"0000ae004301"],
	[70,30,80,0,0,"0000ae004309"],
	[80,30,80,0,0,"0000ae004317"],
	[90,30,80,0,0,"0000ae004325"],
	[100,30,80,0,0,"0000ae004333"],
	[110,30,80,0,0,"0000ae004341"],
	[120,30,80,0,0,"0000ae004349"],
	[130,30,80,0,0,"0000ae004357"],
	[140,30,80,0,0,"0000ae004365"],
	[150,30,80,0,0,"0000ae004373"],
	[30,40,80,0,0,"0000ae004381"],
	[40,40,80,0,0,"0000ae004389"],
	[50,40,80,0,0,"0000ae004397"],
	[60,40,80,0,0,"0000ae004405"],
	[70,40,80,0,0,"0000ae004413"],
	[80,40,80,0,0,"0000ae004421"],
	[90,40,80,0,0,"0000ae004429"],
	[100,40,80,0,0,"0000ae004437"],
	[110,40,80,0,0,"0000ae004445"],
	[120,40,80,0,0,"0000ae004453"],
	[130,40,80,0,0,"0000ae004461"],
	[140,40,80,0,0,"0000ae004469"],
	[150,40,80,0,0,"0000ae004477"],
	[30,50,80,0,0,"0000ae004485"],
	[40,50,80,0,0,"0000ae004493"],
	[50,50,80,0,0,"0000ae004501"],
	[60,50,80,0,0,"0000ae004509"],
	[70,50,80,0,0,"0000ae004517"],
	[80,50,80,0,0,"0000ae004525"],
	[90,50,80,0,0,"0000ae004533"],
	[100,50,80,0,0,"0000ae004541"],
	[110,50,80,0,0,"0000ae004549"],
	[120,50,80,0,0,"0000ae004557"],
	[130,50,80,0,0,"0000ae004565"],
	[140,50,80,0,0,"0000ae004573"],
	[150,50,80,0,0,"0000ae004581"],
	[30,60,80,0,0,"0000ae004589"],
	[40,60,80,0,0,"0000ae004597"],
	[50,60,80,0,0,"0000ae004605"],
	[60,60,80,0,0,"0000ae004613"],
	[70,60,80,0,0,"0000ae004621"],
	[80,60,80,0,0,"0000ae004629"],
	[90,60,80,0,0,"0000ae004637"],
	[100,60,80,0,0,"0000ae004645"],
	[110,60,80,0,0,"0000ae004653"],
	[120,60,80,0,0,"0000ae004661"],
	[130,60,80,0,0,"0000ae004669"],
	[140,60,80,0,0,"0000ae004677"],
	[150,60,80,0,0,"0000ae004685"],
	[30,70,80,0,0,"0000ae004693"],
	[40,70,80,0,0,"0000ae004701"],
	[50,70,80,0,0,"0000ae004709"],
	[60,70,80,0,0,"0000ae004717"],
	[70,70,80,0,0,"0000ae004725"],
	[80,70,80,0,0,"0000ae004733"],
	[90,70,80,0,0,"0000ae004741"],
	[100,70,80,0,0,"0000ae004749"],
	[110,70,80,0,0,"0000ae004757"],
	[120,70,80,0,0,"0000ae004765"],
	[130,70,80,0,0,"0000ae004773"],
	[140,70,80,0,0,"0000ae004781"],
	[150,70,80,0,0,"0000ae004789"],
	[30,80,80,0,0,"0000ae004797"],
	[40,80,80,0,0,"0000ae004805"],
	[50,80,80,0,0,"0000ae004813"],
	[60,80,80,0,0,"0000ae004821"],
	[70,80,80,0,0,"0000ae004829"],
	[80,80,80,0,0,"0000ae004837"],
	[90,80,80,0,0,"0000ae004845"],
	[100,80,80,0,0,"0000ae004853"],
	[110,80,80,0,0,"0000ae004861"],
	[120,80,80,0,0,"0000ae004869"],
	[130,80,80,0,0,"0000ae004877"],
	[140,80,80,0,0,"0000ae004885"],
	[150,80,80,0,0,"0000ae004893"],
	[30,90,80,0,0,"0000ae004901"],
	[40,90,80,0,0,"0000ae004909"],
	[50,90,80,0,0,"0000ae004917"],
	[60,90,80,0,0,"0000ae004925"],
	[70,90,80,0,0,"0000ae004933"],
	[80,90,80,0,0,"0000ae004941"],
	[90,90,80,0,0,"0000ae004949"],
	[100,90,80,0,0,"0000ae004957"],
	[110,90,80,0,0,"0000ae004965"],
	[120,90,80,0,0,"0000ae004973"],
	[130,90,80,0,0,"0000ae004981"],
	[140,90,80,0,0,"0000ae004989"],
	[150,90,80,0,0,"0000ae004997"],
	[30,20,90,0,0,"0000ae005005"],
	[40,20,90,0,0,"0000ae005013"],
	[50,20,90,0,0,"0000ae005021"],
	[60,20,90,0,0,"0000ae005029"],
	[70,20,90,0,0,"0000ae005037"],
	[80,20,90,0,0,"0000ae005045"],
	[90,20,90,0,0,"0000ae005053"],
	[100,20,90,0,0,"0000ae005061"],
	[110,20,90,0,0,"0000ae005069"],
	[120,20,90,0,0,"0000ae005077"],
	[130,20,90,0,0,"0000ae005085"],
	[140,20,90,0,0,"0000ae005093"],
	[150,20,90,0,0,"0000ae005101"],
	[30,30,90,0,0,"0000ae005109"],
	[40,30,90,0,0,"0000ae005117"],
	[50,30,90,0,0,"0000ae005125"],
	[60,30,90,0,0,"0000ae005133"],
	[70,30,90,0,0,"0000ae005141"],
	[80,30,90,0,0,"0000ae005149"],
	[90,30,90,0,0,"0000ae005157"],
	[100,30,90,0,0,"0000ae005165"],
	[110,30,90,0,0,"0000ae005173"],
	[120,30,90,0,0,"0000ae005181"],
	[130,30,90,0,0,"0000ae005189"],
	[140,30,90,0,0,"0000ae005197"],
	[150,30,90,0,0,"0000ae005205"],
	[30,40,90,0,0,"0000ae005213"],
	[40,40,90,0,0,"0000ae005221"],
	[50,40,90,0,0,"0000ae005229"],
	[60,40,90,0,0,"0000ae005237"],
	[70,40,90,0,0,"0000ae005245"],
	[80,40,90,0,0,"0000ae005253"],
	[90,40,90,0,0,"0000ae005261"],
	[100,40,90,0,0,"0000ae005269"],
	[110,40,90,0,0,"0000ae005277"],
	[120,40,90,0,0,"0000ae005285"],
	[130,40,90,0,0,"0000ae005293"],
	[140,40,90,0,0,"0000ae005301"],
	[150,40,90,0,0,"0000ae005309"],
	[30,50,90,0,0,"0000ae005317"],
	[40,50,90,0,0,"0000ae005325"],
	[50,50,90,0,0,"0000ae005333"],
	[60,50,90,0,0,"0000ae005341"],
	[70,50,90,0,0,"0000ae005349"],
	[80,50,90,0,0,"0000ae005357"],
	[90,50,90,0,0,"0000ae005365"],
	[100,50,90,0,0,"0000ae005373"],
	[110,50,90,0,0,"0000ae005381"],
	[120,50,90,0,0,"0000ae005389"],
	[130,50,90,0,0,"0000ae005397"],
	[140,50,90,0,0,"0000ae005405"],
	[150,50,90,0,0,"0000ae005413"],
	[30,60,90,0,0,"0000ae005421"],
	[40,60,90,0,0,"0000ae005429"],
	[50,60,90,0,0,"0000ae005437"],
	[60,60,90,0,0,"0000ae005445"],
	[70,60,90,0,0,"0000ae005453"],
	[80,60,90,0,0,"0000ae005461"],
	[90,60,90,0,0,"0000ae005469"],
	[100,60,90,0,0,"0000ae005477"],
	[110,60,90,0,0,"0000ae005485"],
	[120,60,90,0,0,"0000ae005493"],
	[130,60,90,0,0,"0000ae005501"],
	[140,60,90,0,0,"0000ae005509"],
	[150,60,90,0,0,"0000ae005517"],
	[30,70,90,0,0,"0000ae005525"],
	[40,70,90,0,0,"0000ae005533"],
	[50,70,90,0,0,"0000ae005541"],
	[60,70,90,0,0,"0000ae005549"],
	[70,70,90,0,0,"0000ae005557"],
	[80,70,90,0,0,"0000ae005565"],
	[90,70,90,0,0,"0000ae005573"],
	[100,70,90,0,0,"0000ae005581"],
	[110,70,90,0,0,"0000ae005589"],
	[120,70,90,0,0,"0000ae005597"],
	[130,70,90,0,0,"0000ae005605"],
	[140,70,90,0,0,"0000ae005613"],
	[150,70,90,0,0,"0000ae005621"],
	[30,80,90,0,0,"0000ae005629"],
	[40,80,90,0,0,"0000ae005637"],
	[50,80,90,0,0,"0000ae005645"],
	[60,80,90,0,0,"0000ae005653"],
	[70,80,90,0,0,"0000ae005661"],
	[80,80,90,0,0,"0000ae005669"],
	[90,80,90,0,0,"0000ae005677"],
	[100,80,90,0,0,"0000ae005685"],
	[110,80,90,0,0,"0000ae005693"],
	[120,80,90,0,0,"0000ae005701"],
	[130,80,90,0,0,"0000ae005709"],
	[140,80,90,0,0,"0000ae005717"],
	[150,80,90,0,0,"0000ae005725"],
	[30,90,90,0,0,"0000ae005733"],
	[40,90,90,0,0,"0000ae005741"],
	[50,90,90,0,0,"0000ae005749"],
	[60,90,90,0,0,"0000ae005757"],
	[70,90,90,0,0,"0000ae005765"],
	[80,90,90,0,0,"0000ae005773"],
	[90,90,90,0,0,"0000ae005781"],
	[100,90,90,0,0,"0000ae005789"],
	[110,90,90,0,0,"0000ae005797"],
	[120,90,90,0,0,"0000ae005805"],
	[130,90,90,0,0,"0000ae005813"],
	[140,90,90,0,0,"0000ae005821"],
	[150,90,90,0,0,"0000ae005829"],
	[30,20,100,0,0,"0000ae005837"],
	[40,20,100,0,0,"0000ae005845"],
	[50,20,100,0,0,"0000ae005853"],
	[60,20,100,0,0,"0000ae005861"],
	[70,20,100,0,0,"0000ae005869"],
	[80,20,100,0,0,"0000ae005877"],
	[90,20,100,0,0,"0000ae005885"],
	[100,20,100,0,0,"0000ae005893"],
	[110,20,100,0,0,"0000ae005901"],
	[120,20,100,0,0,"0000ae005909"],
	[130,20,100,0,0,"0000ae005917"],
	[140,20,100,0,0,"0000ae005925"],
	[150,20,100,0,0,"0000ae005933"],
	[30,30,100,0,0,"0000ae005941"],
	[40,30,100,0,0,"0000ae005949"],
	[50,30,100,0,0,"0000ae005957"],
	[60,30,100,0,0,"0000ae005965"],
	[70,30,100,0,0,"0000ae005973"],
	[80,30,100,0,0,"0000ae005981"],
	[90,30,100,0,0,"0000ae005989"],
	[100,30,100,0,0,"0000ae005997"],
	[110,30,100,0,0,"0000ae006005"],
	[120,30,100,0,0,"0000ae006013"],
	[130,30,100,0,0,"0000ae006021"],
	[140,30,100,0,0,"0000ae006029"],
	[150,30,100,0,0,"0000ae006037"],
	[30,40,100,0,0,"0000ae006045"],
	[40,40,100,0,0,"0000ae006053"],
	[50,40,100,0,0,"0000ae006061"],
	[60,40,100,0,0,"0000ae006069"],
	[70,40,100,0,0,"0000ae006077"],
	[80,40,100,0,0,"0000ae006085"],
	[90,40,100,0,0,"0000ae006093"],
	[100,40,100,0,0,"0000ae006101"],
	[110,40,100,0,0,"0000ae006109"],
	[120,40,100,0,0,"0000ae006117"],
	[130,40,100,0,0,"0000ae006125"],
	[140,40,100,0,0,"0000ae006133"],
	[150,40,100,0,0,"0000ae006141"],
	[30,50,100,0,0,"0000ae006149"],
	[40,50,100,0,0,"0000ae006157"],
	[50,50,100,0,0,"0000ae006165"],
	[60,50,100,0,0,"0000ae006173"],
	[70,50,100,0,0,"0000ae006181"],
	[80,50,100,0,0,"0000ae006189"],
	[90,50,100,0,0,"0000ae006197"],
	[100,50,100,0,0,"0000ae006205"],
	[110,50,100,0,0,"0000ae006213"],
	[120,50,100,0,0,"0000ae006221"],
	[130,50,100,0,0,"0000ae006229"],
	[140,50,100,0,0,"0000ae006237"],
	[150,50,100,0,0,"0000ae006245"],
	[30,60,100,0,0,"0000ae006253"],
	[40,60,100,0,0,"0000ae006261"],
	[50,60,100,0,0,"0000ae006269"],
	[60,60,100,0,0,"0000ae006277"],
	[70,60,100,0,0,"0000ae006285"],
	[80,60,100,0,0,"0000ae006293"],
	[90,60,100,0,0,"0000ae006301"],
	[100,60,100,0,0,"0000ae006309"],
	[110,60,100,0,0,"0000ae006317"],
	[120,60,100,0,0,"0000ae006325"],
	[130,60,100,0,0,"0000ae006333"],
	[140,60,100,0,0,"0000ae006341"],
	[150,60,100,0,0,"0000ae006349"],
	[30,70,100,0,0,"0000ae006357"],
	[40,70,100,0,0,"0000ae006365"],
	[50,70,100,0,0,"0000ae006373"],
	[60,70,100,0,0,"0000ae006381"],
	[70,70,100,0,0,"0000ae006389"],
	[80,70,100,0,0,"0000ae006397"],
	[90,70,100,0,0,"0000ae006405"],
	[100,70,100,0,0,"0000ae006413"],
	[110,70,100,0,0,"0000ae006421"],
	[120,70,100,0,0,"0000ae006429"],
	[130,70,100,0,0,"0000ae006437"],
	[140,70,100,0,0,"0000ae006445"],
	[150,70,100,0,0,"0000ae006453"],
	[30,80,100,0,0,"0000ae006461"],
	[40,80,100,0,0,"0000ae006469"],
	[50,80,100,0,0,"0000ae006477"],
	[60,80,100,0,0,"0000ae006485"],
	[70,80,100,0,0,"0000ae006493"],
	[80,80,100,0,0,"0000ae006501"],
	[90,80,100,0,0,"0000ae006509"],
	[100,80,100,0,0,"0000ae006517"],
	[110,80,100,0,0,"0000ae006525"],
	[120,80,100,0,0,"0000ae006533"],
	[130,80,100,0,0,"0000ae006541"],
	[140,80,100,0,0,"0000ae006549"],
	[150,80,100,0,0,"0000ae006557"],
	[30,90,100,0,0,"0000ae006565"],
	[40,90,100,0,0,"0000ae006573"],
	[50,90,100,0,0,"0000ae006581"],
	[60,90,100,0,0,"0000ae006589"],
	[70,90,100,0,0,"0000ae006597"],
	[80,90,100,0,0,"0000ae006605"],
	[90,90,100,0,0,"0000ae006613"],
	[100,90,100,0,0,"0000ae006621"],
	[110,90,100,0,0,"0000ae006629"],
	[120,90,100,0,0,"0000ae006637"],
	[130,90,100,0,0,"0000ae006645"],
	[140,90,100,0,0,"0000ae006653"],
	[150,90,100,0,0,"0000ae006661"],/*
	[30,20,40,1,0,"0000ae006669"],
	[40,20,40,1,0,"0000ae006677"],
	[50,20,40,1,0,"0000ae006685"],
	[60,20,40,1,0,"0000ae006693"],
	[70,20,40,1,0,"0000ae006701"],
	[80,20,40,1,0,"0000ae006709"],
	[90,20,40,1,0,"0000ae006717"],
	[100,20,40,1,0,"0000ae006725"],
	[110,20,40,1,0,"0000ae006733"],
	[120,20,40,1,0,"0000ae006741"],
	[130,20,40,1,0,"0000ae006749"],
	[140,20,40,1,0,"0000ae006757"],
	[150,20,40,1,0,"0000ae006765"],
	[30,30,40,1,0,"0000ae006773"],
	[40,30,40,1,0,"0000ae006781"],
	[50,30,40,1,0,"0000ae006789"],
	[60,30,40,1,0,"0000ae006797"],
	[70,30,40,1,0,"0000ae006805"],
	[80,30,40,1,0,"0000ae006813"],
	[90,30,40,1,0,"0000ae006821"],
	[100,30,40,1,0,"0000ae006829"],
	[110,30,40,1,0,"0000ae006837"],
	[120,30,40,1,0,"0000ae006845"],
	[130,30,40,1,0,"0000ae006853"],
	[140,30,40,1,0,"0000ae006861"],
	[150,30,40,1,0,"0000ae006869"],
	[30,40,40,1,0,"0000ae006877"],
	[40,40,40,1,0,"0000ae006885"],
	[50,40,40,1,0,"0000ae006893"],
	[60,40,40,1,0,"0000ae006901"],
	[70,40,40,1,0,"0000ae006909"],
	[80,40,40,1,0,"0000ae006917"],
	[90,40,40,1,0,"0000ae006925"],
	[100,40,40,1,0,"0000ae006933"],
	[110,40,40,1,0,"0000ae006941"],
	[120,40,40,1,0,"0000ae006949"],
	[130,40,40,1,0,"0000ae006957"],
	[140,40,40,1,0,"0000ae006965"],
	[150,40,40,1,0,"0000ae006973"],
	[30,50,40,1,0,"0000ae006981"],
	[40,50,40,1,0,"0000ae006989"],
	[50,50,40,1,0,"0000ae006997"],
	[60,50,40,1,0,"0000ae007005"],
	[70,50,40,1,0,"0000ae007013"],
	[80,50,40,1,0,"0000ae007021"],
	[90,50,40,1,0,"0000ae007029"],
	[100,50,40,1,0,"0000ae007037"],
	[110,50,40,1,0,"0000ae007045"],
	[120,50,40,1,0,"0000ae007053"],
	[130,50,40,1,0,"0000ae007061"],
	[140,50,40,1,0,"0000ae007069"],
	[150,50,40,1,0,"0000ae007077"],
	[30,60,40,1,0,"0000ae007085"],
	[40,60,40,1,0,"0000ae007093"],
	[50,60,40,1,0,"0000ae007101"],
	[60,60,40,1,0,"0000ae007109"],
	[70,60,40,1,0,"0000ae007117"],
	[80,60,40,1,0,"0000ae007125"],
	[90,60,40,1,0,"0000ae007133"],
	[100,60,40,1,0,"0000ae007141"],
	[110,60,40,1,0,"0000ae007149"],
	[120,60,40,1,0,"0000ae007157"],
	[130,60,40,1,0,"0000ae007165"],
	[140,60,40,1,0,"0000ae007173"],
	[150,60,40,1,0,"0000ae007181"],
	[30,70,40,1,0,"0000ae007189"],
	[40,70,40,1,0,"0000ae007197"],
	[50,70,40,1,0,"0000ae007205"],
	[60,70,40,1,0,"0000ae007213"],
	[70,70,40,1,0,"0000ae007221"],
	[80,70,40,1,0,"0000ae007229"],
	[90,70,40,1,0,"0000ae007237"],
	[100,70,40,1,0,"0000ae007245"],
	[110,70,40,1,0,"0000ae007253"],
	[120,70,40,1,0,"0000ae007261"],
	[130,70,40,1,0,"0000ae007269"],
	[140,70,40,1,0,"0000ae007277"],
	[150,70,40,1,0,"0000ae007285"],
	[30,80,40,1,0,"0000ae007293"],
	[40,80,40,1,0,"0000ae007301"],
	[50,80,40,1,0,"0000ae007309"],
	[60,80,40,1,0,"0000ae007317"],
	[70,80,40,1,0,"0000ae007325"],
	[80,80,40,1,0,"0000ae007333"],
	[90,80,40,1,0,"0000ae007341"],
	[100,80,40,1,0,"0000ae007349"],
	[110,80,40,1,0,"0000ae007357"],
	[120,80,40,1,0,"0000ae007365"],
	[130,80,40,1,0,"0000ae007373"],
	[140,80,40,1,0,"0000ae007381"],
	[150,80,40,1,0,"0000ae007389"],
	[30,90,40,1,0,"0000ae007397"],
	[40,90,40,1,0,"0000ae007405"],
	[50,90,40,1,0,"0000ae007413"],
	[60,90,40,1,0,"0000ae007421"],
	[70,90,40,1,0,"0000ae007429"],
	[80,90,40,1,0,"0000ae007437"],
	[90,90,40,1,0,"0000ae007445"],
	[100,90,40,1,0,"0000ae007453"],
	[110,90,40,1,0,"0000ae007461"],
	[120,90,40,1,0,"0000ae007469"],
	[130,90,40,1,0,"0000ae007477"],
	[140,90,40,1,0,"0000ae007485"],
	[150,90,40,1,0,"0000ae007493"],
	[30,20,50,1,0,"0000ae007501"],
	[40,20,50,1,0,"0000ae007509"],
	[50,20,50,1,0,"0000ae007517"],
	[60,20,50,1,0,"0000ae007525"],
	[70,20,50,1,0,"0000ae007533"],
	[80,20,50,1,0,"0000ae007541"],
	[90,20,50,1,0,"0000ae007549"],
	[100,20,50,1,0,"0000ae007557"],
	[110,20,50,1,0,"0000ae007565"],
	[120,20,50,1,0,"0000ae007573"],
	[130,20,50,1,0,"0000ae007581"],
	[140,20,50,1,0,"0000ae007589"],
	[150,20,50,1,0,"0000ae007597"],
	[30,30,50,1,0,"0000ae007605"],
	[40,30,50,1,0,"0000ae007613"],
	[50,30,50,1,0,"0000ae007621"],
	[60,30,50,1,0,"0000ae007629"],
	[70,30,50,1,0,"0000ae007637"],
	[80,30,50,1,0,"0000ae007645"],
	[90,30,50,1,0,"0000ae007653"],
	[100,30,50,1,0,"0000ae007661"],
	[110,30,50,1,0,"0000ae007669"],
	[120,30,50,1,0,"0000ae007677"],
	[130,30,50,1,0,"0000ae007685"],
	[140,30,50,1,0,"0000ae007693"],
	[150,30,50,1,0,"0000ae007701"],
	[30,40,50,1,0,"0000ae007709"],
	[40,40,50,1,0,"0000ae007717"],
	[50,40,50,1,0,"0000ae007725"],
	[60,40,50,1,0,"0000ae007733"],
	[70,40,50,1,0,"0000ae007741"],
	[80,40,50,1,0,"0000ae007749"],
	[90,40,50,1,0,"0000ae007757"],
	[100,40,50,1,0,"0000ae007765"],
	[110,40,50,1,0,"0000ae007773"],
	[120,40,50,1,0,"0000ae007781"],
	[130,40,50,1,0,"0000ae007789"],
	[140,40,50,1,0,"0000ae007797"],
	[150,40,50,1,0,"0000ae007805"],
	[30,50,50,1,0,"0000ae007813"],
	[40,50,50,1,0,"0000ae007821"],
	[50,50,50,1,0,"0000ae007829"],
	[60,50,50,1,0,"0000ae007837"],
	[70,50,50,1,0,"0000ae007845"],
	[80,50,50,1,0,"0000ae007853"],
	[90,50,50,1,0,"0000ae007861"],
	[100,50,50,1,0,"0000ae007869"],
	[110,50,50,1,0,"0000ae007877"],
	[120,50,50,1,0,"0000ae007885"],
	[130,50,50,1,0,"0000ae007893"],
	[140,50,50,1,0,"0000ae007901"],
	[150,50,50,1,0,"0000ae007909"],
	[30,60,50,1,0,"0000ae007917"],
	[40,60,50,1,0,"0000ae007925"],
	[50,60,50,1,0,"0000ae007933"],
	[60,60,50,1,0,"0000ae007941"],
	[70,60,50,1,0,"0000ae007949"],
	[80,60,50,1,0,"0000ae007957"],
	[90,60,50,1,0,"0000ae007965"],
	[100,60,50,1,0,"0000ae007973"],
	[110,60,50,1,0,"0000ae007981"],
	[120,60,50,1,0,"0000ae007989"],
	[130,60,50,1,0,"0000ae007997"],
	[140,60,50,1,0,"0000ae008005"],
	[150,60,50,1,0,"0000ae008013"],
	[30,70,50,1,0,"0000ae008021"],
	[40,70,50,1,0,"0000ae008029"],
	[50,70,50,1,0,"0000ae008037"],
	[60,70,50,1,0,"0000ae008045"],
	[70,70,50,1,0,"0000ae008053"],
	[80,70,50,1,0,"0000ae008061"],
	[90,70,50,1,0,"0000ae008069"],
	[100,70,50,1,0,"0000ae008077"],
	[110,70,50,1,0,"0000ae008085"],
	[120,70,50,1,0,"0000ae008093"],
	[130,70,50,1,0,"0000ae008101"],
	[140,70,50,1,0,"0000ae008109"],
	[150,70,50,1,0,"0000ae008117"],
	[30,80,50,1,0,"0000ae008125"],
	[40,80,50,1,0,"0000ae008133"],
	[50,80,50,1,0,"0000ae008141"],
	[60,80,50,1,0,"0000ae008149"],
	[70,80,50,1,0,"0000ae008157"],
	[80,80,50,1,0,"0000ae008165"],
	[90,80,50,1,0,"0000ae008173"],
	[100,80,50,1,0,"0000ae008181"],
	[110,80,50,1,0,"0000ae008189"],
	[120,80,50,1,0,"0000ae008197"],
	[130,80,50,1,0,"0000ae008205"],
	[140,80,50,1,0,"0000ae008213"],
	[150,80,50,1,0,"0000ae008221"],
	[30,90,50,1,0,"0000ae008229"],
	[40,90,50,1,0,"0000ae008237"],
	[50,90,50,1,0,"0000ae008245"],
	[60,90,50,1,0,"0000ae008253"],
	[70,90,50,1,0,"0000ae008261"],
	[80,90,50,1,0,"0000ae008269"],
	[90,90,50,1,0,"0000ae008277"],
	[100,90,50,1,0,"0000ae008285"],
	[110,90,50,1,0,"0000ae008293"],
	[120,90,50,1,0,"0000ae008301"],
	[130,90,50,1,0,"0000ae008309"],
	[140,90,50,1,0,"0000ae008317"],
	[150,90,50,1,0,"0000ae008325"],
	[30,20,60,1,0,"0000ae008333"],
	[40,20,60,1,0,"0000ae008341"],
	[50,20,60,1,0,"0000ae008349"],
	[60,20,60,1,0,"0000ae008357"],
	[70,20,60,1,0,"0000ae008365"],
	[80,20,60,1,0,"0000ae008373"],
	[90,20,60,1,0,"0000ae008381"],
	[100,20,60,1,0,"0000ae008389"],
	[110,20,60,1,0,"0000ae008397"],
	[120,20,60,1,0,"0000ae008405"],
	[130,20,60,1,0,"0000ae008413"],
	[140,20,60,1,0,"0000ae008421"],
	[150,20,60,1,0,"0000ae008429"],
	[30,30,60,1,0,"0000ae008437"],
	[40,30,60,1,0,"0000ae008445"],
	[50,30,60,1,0,"0000ae008453"],
	[60,30,60,1,0,"0000ae008461"],
	[70,30,60,1,0,"0000ae008469"],
	[80,30,60,1,0,"0000ae008477"],
	[90,30,60,1,0,"0000ae008485"],
	[100,30,60,1,0,"0000ae008493"],
	[110,30,60,1,0,"0000ae008501"],
	[120,30,60,1,0,"0000ae008509"],
	[130,30,60,1,0,"0000ae008517"],
	[140,30,60,1,0,"0000ae008525"],
	[150,30,60,1,0,"0000ae008533"],
	[30,40,60,1,0,"0000ae008541"],
	[40,40,60,1,0,"0000ae008549"],
	[50,40,60,1,0,"0000ae008557"],
	[60,40,60,1,0,"0000ae008565"],
	[70,40,60,1,0,"0000ae008573"],
	[80,40,60,1,0,"0000ae008581"],
	[90,40,60,1,0,"0000ae008589"],
	[100,40,60,1,0,"0000ae008597"],
	[110,40,60,1,0,"0000ae008605"],
	[120,40,60,1,0,"0000ae008613"],
	[130,40,60,1,0,"0000ae008621"],
	[140,40,60,1,0,"0000ae008629"],
	[150,40,60,1,0,"0000ae008637"],
	[30,50,60,1,0,"0000ae008645"],
	[40,50,60,1,0,"0000ae008653"],
	[50,50,60,1,0,"0000ae008661"],
	[60,50,60,1,0,"0000ae008669"],
	[70,50,60,1,0,"0000ae008677"],
	[80,50,60,1,0,"0000ae008685"],
	[90,50,60,1,0,"0000ae008693"],
	[100,50,60,1,0,"0000ae008701"],
	[110,50,60,1,0,"0000ae008709"],
	[120,50,60,1,0,"0000ae008717"],
	[130,50,60,1,0,"0000ae008725"],
	[140,50,60,1,0,"0000ae008733"],
	[150,50,60,1,0,"0000ae008741"],
	[30,60,60,1,0,"0000ae008749"],
	[40,60,60,1,0,"0000ae008757"],
	[50,60,60,1,0,"0000ae008765"],
	[60,60,60,1,0,"0000ae008773"],
	[70,60,60,1,0,"0000ae008781"],
	[80,60,60,1,0,"0000ae008789"],
	[90,60,60,1,0,"0000ae008797"],
	[100,60,60,1,0,"0000ae008805"],
	[110,60,60,1,0,"0000ae008813"],
	[120,60,60,1,0,"0000ae008821"],
	[130,60,60,1,0,"0000ae008829"],
	[140,60,60,1,0,"0000ae008837"],
	[150,60,60,1,0,"0000ae008845"],
	[30,70,60,1,0,"0000ae008853"],
	[40,70,60,1,0,"0000ae008861"],
	[50,70,60,1,0,"0000ae008869"],
	[60,70,60,1,0,"0000ae008877"],
	[70,70,60,1,0,"0000ae008885"],
	[80,70,60,1,0,"0000ae008893"],
	[90,70,60,1,0,"0000ae008901"],
	[100,70,60,1,0,"0000ae008909"],
	[110,70,60,1,0,"0000ae008917"],
	[120,70,60,1,0,"0000ae008925"],
	[130,70,60,1,0,"0000ae008933"],
	[140,70,60,1,0,"0000ae008941"],
	[150,70,60,1,0,"0000ae008949"],
	[30,80,60,1,0,"0000ae008957"],
	[40,80,60,1,0,"0000ae008965"],
	[50,80,60,1,0,"0000ae008973"],
	[60,80,60,1,0,"0000ae008981"],
	[70,80,60,1,0,"0000ae008989"],
	[80,80,60,1,0,"0000ae008997"],
	[90,80,60,1,0,"0000ae009005"],
	[100,80,60,1,0,"0000ae009013"],
	[110,80,60,1,0,"0000ae009021"],
	[120,80,60,1,0,"0000ae009029"],
	[130,80,60,1,0,"0000ae009037"],
	[140,80,60,1,0,"0000ae009045"],
	[150,80,60,1,0,"0000ae009053"],
	[30,90,60,1,0,"0000ae009061"],
	[40,90,60,1,0,"0000ae009069"],
	[50,90,60,1,0,"0000ae009077"],
	[60,90,60,1,0,"0000ae009085"],
	[70,90,60,1,0,"0000ae009093"],
	[80,90,60,1,0,"0000ae009101"],
	[90,90,60,1,0,"0000ae009109"],
	[100,90,60,1,0,"0000ae009117"],
	[110,90,60,1,0,"0000ae009125"],
	[120,90,60,1,0,"0000ae009133"],
	[130,90,60,1,0,"0000ae009141"],
	[140,90,60,1,0,"0000ae009149"],
	[150,90,60,1,0,"0000ae009157"],
	[30,20,70,1,0,"0000ae009165"],
	[40,20,70,1,0,"0000ae009173"],
	[50,20,70,1,0,"0000ae009181"],
	[60,20,70,1,0,"0000ae009189"],
	[70,20,70,1,0,"0000ae009197"],
	[80,20,70,1,0,"0000ae009205"],
	[90,20,70,1,0,"0000ae009213"],
	[100,20,70,1,0,"0000ae009221"],
	[110,20,70,1,0,"0000ae009229"],
	[120,20,70,1,0,"0000ae009237"],
	[130,20,70,1,0,"0000ae009245"],
	[140,20,70,1,0,"0000ae009253"],
	[150,20,70,1,0,"0000ae009261"],
	[30,30,70,1,0,"0000ae009269"],
	[40,30,70,1,0,"0000ae009277"],
	[50,30,70,1,0,"0000ae009285"],
	[60,30,70,1,0,"0000ae009293"],
	[70,30,70,1,0,"0000ae009301"],
	[80,30,70,1,0,"0000ae009309"],
	[90,30,70,1,0,"0000ae009317"],
	[100,30,70,1,0,"0000ae009325"],
	[110,30,70,1,0,"0000ae009333"],
	[120,30,70,1,0,"0000ae009341"],
	[130,30,70,1,0,"0000ae009349"],
	[140,30,70,1,0,"0000ae009357"],
	[150,30,70,1,0,"0000ae009365"],
	[30,40,70,1,0,"0000ae009373"],
	[40,40,70,1,0,"0000ae009381"],
	[50,40,70,1,0,"0000ae009389"],
	[60,40,70,1,0,"0000ae009397"],
	[70,40,70,1,0,"0000ae009405"],
	[80,40,70,1,0,"0000ae009413"],
	[90,40,70,1,0,"0000ae009421"],
	[100,40,70,1,0,"0000ae009429"],
	[110,40,70,1,0,"0000ae009437"],
	[120,40,70,1,0,"0000ae009445"],
	[130,40,70,1,0,"0000ae009453"],
	[140,40,70,1,0,"0000ae009461"],
	[150,40,70,1,0,"0000ae009469"],
	[30,50,70,1,0,"0000ae009477"],
	[40,50,70,1,0,"0000ae009485"],
	[50,50,70,1,0,"0000ae009493"],
	[60,50,70,1,0,"0000ae009501"],
	[70,50,70,1,0,"0000ae009509"],
	[80,50,70,1,0,"0000ae009517"],
	[90,50,70,1,0,"0000ae009525"],
	[100,50,70,1,0,"0000ae009533"],
	[110,50,70,1,0,"0000ae009541"],
	[120,50,70,1,0,"0000ae009549"],
	[130,50,70,1,0,"0000ae009557"],
	[140,50,70,1,0,"0000ae009565"],
	[150,50,70,1,0,"0000ae009573"],
	[30,60,70,1,0,"0000ae009581"],
	[40,60,70,1,0,"0000ae009589"],
	[50,60,70,1,0,"0000ae009597"],
	[60,60,70,1,0,"0000ae009605"],
	[70,60,70,1,0,"0000ae009613"],
	[80,60,70,1,0,"0000ae009621"],
	[90,60,70,1,0,"0000ae009629"],
	[100,60,70,1,0,"0000ae009637"],
	[110,60,70,1,0,"0000ae009645"],
	[120,60,70,1,0,"0000ae009653"],
	[130,60,70,1,0,"0000ae009661"],
	[140,60,70,1,0,"0000ae009669"],
	[150,60,70,1,0,"0000ae009677"],
	[30,70,70,1,0,"0000ae009685"],
	[40,70,70,1,0,"0000ae009693"],
	[50,70,70,1,0,"0000ae009701"],
	[60,70,70,1,0,"0000ae009709"],
	[70,70,70,1,0,"0000ae009717"],
	[80,70,70,1,0,"0000ae009725"],
	[90,70,70,1,0,"0000ae009733"],
	[100,70,70,1,0,"0000ae009741"],
	[110,70,70,1,0,"0000ae009749"],
	[120,70,70,1,0,"0000ae009757"],
	[130,70,70,1,0,"0000ae009765"],
	[140,70,70,1,0,"0000ae009773"],
	[150,70,70,1,0,"0000ae009781"],
	[30,80,70,1,0,"0000ae009789"],
	[40,80,70,1,0,"0000ae009797"],
	[50,80,70,1,0,"0000ae009805"],
	[60,80,70,1,0,"0000ae009813"],
	[70,80,70,1,0,"0000ae009821"],
	[80,80,70,1,0,"0000ae009829"],
	[90,80,70,1,0,"0000ae009837"],
	[100,80,70,1,0,"0000ae009845"],
	[110,80,70,1,0,"0000ae009853"],
	[120,80,70,1,0,"0000ae009861"],
	[130,80,70,1,0,"0000ae009869"],
	[140,80,70,1,0,"0000ae009877"],
	[150,80,70,1,0,"0000ae009885"],
	[30,90,70,1,0,"0000ae009893"],
	[40,90,70,1,0,"0000ae009901"],
	[50,90,70,1,0,"0000ae009909"],
	[60,90,70,1,0,"0000ae009917"],
	[70,90,70,1,0,"0000ae009925"],
	[80,90,70,1,0,"0000ae009933"],
	[90,90,70,1,0,"0000ae009941"],
	[100,90,70,1,0,"0000ae009949"],
	[110,90,70,1,0,"0000ae009957"],
	[120,90,70,1,0,"0000ae009965"],
	[130,90,70,1,0,"0000ae009973"],
	[140,90,70,1,0,"0000ae009981"],
	[150,90,70,1,0,"0000ae009989"],
	[30,20,80,1,0,"0000ae009997"],
	[40,20,80,1,0,"0000ae010005"],
	[50,20,80,1,0,"0000ae010013"],
	[60,20,80,1,0,"0000ae010021"],
	[70,20,80,1,0,"0000ae010029"],
	[80,20,80,1,0,"0000ae010037"],
	[90,20,80,1,0,"0000ae010045"],
	[100,20,80,1,0,"0000ae010053"],
	[110,20,80,1,0,"0000ae010061"],
	[120,20,80,1,0,"0000ae010069"],
	[130,20,80,1,0,"0000ae010077"],
	[140,20,80,1,0,"0000ae010085"],
	[150,20,80,1,0,"0000ae010093"],
	[30,30,80,1,0,"0000ae010101"],
	[40,30,80,1,0,"0000ae010109"],
	[50,30,80,1,0,"0000ae010117"],
	[60,30,80,1,0,"0000ae010125"],
	[70,30,80,1,0,"0000ae010133"],
	[80,30,80,1,0,"0000ae010141"],
	[90,30,80,1,0,"0000ae010149"],
	[100,30,80,1,0,"0000ae010157"],
	[110,30,80,1,0,"0000ae010165"],
	[120,30,80,1,0,"0000ae010173"],
	[130,30,80,1,0,"0000ae010181"],
	[140,30,80,1,0,"0000ae010189"],
	[150,30,80,1,0,"0000ae010197"],
	[30,40,80,1,0,"0000ae010205"],
	[40,40,80,1,0,"0000ae010213"],
	[50,40,80,1,0,"0000ae010221"],
	[60,40,80,1,0,"0000ae010229"],
	[70,40,80,1,0,"0000ae010237"],
	[80,40,80,1,0,"0000ae010245"],
	[90,40,80,1,0,"0000ae010253"],
	[100,40,80,1,0,"0000ae010261"],
	[110,40,80,1,0,"0000ae010269"],
	[120,40,80,1,0,"0000ae010277"],
	[130,40,80,1,0,"0000ae010285"],
	[140,40,80,1,0,"0000ae010293"],
	[150,40,80,1,0,"0000ae010301"],
	[30,50,80,1,0,"0000ae010309"],
	[40,50,80,1,0,"0000ae010317"],
	[50,50,80,1,0,"0000ae010325"],
	[60,50,80,1,0,"0000ae010333"],
	[70,50,80,1,0,"0000ae010341"],
	[80,50,80,1,0,"0000ae010349"],
	[90,50,80,1,0,"0000ae010357"],
	[100,50,80,1,0,"0000ae010365"],
	[110,50,80,1,0,"0000ae010373"],
	[120,50,80,1,0,"0000ae010381"],
	[130,50,80,1,0,"0000ae010389"],
	[140,50,80,1,0,"0000ae010397"],
	[150,50,80,1,0,"0000ae010405"],
	[30,60,80,1,0,"0000ae010413"],
	[40,60,80,1,0,"0000ae010421"],
	[50,60,80,1,0,"0000ae010429"],
	[60,60,80,1,0,"0000ae010437"],
	[70,60,80,1,0,"0000ae010445"],
	[80,60,80,1,0,"0000ae010453"],
	[90,60,80,1,0,"0000ae010461"],
	[100,60,80,1,0,"0000ae010469"],
	[110,60,80,1,0,"0000ae010477"],
	[120,60,80,1,0,"0000ae010485"],
	[130,60,80,1,0,"0000ae010493"],
	[140,60,80,1,0,"0000ae010501"],
	[150,60,80,1,0,"0000ae010509"],
	[30,70,80,1,0,"0000ae010517"],
	[40,70,80,1,0,"0000ae010525"],
	[50,70,80,1,0,"0000ae010533"],
	[60,70,80,1,0,"0000ae010541"],
	[70,70,80,1,0,"0000ae010549"],
	[80,70,80,1,0,"0000ae010557"],
	[90,70,80,1,0,"0000ae010565"],
	[100,70,80,1,0,"0000ae010573"],
	[110,70,80,1,0,"0000ae010581"],
	[120,70,80,1,0,"0000ae010589"],
	[130,70,80,1,0,"0000ae010597"],
	[140,70,80,1,0,"0000ae010605"],
	[150,70,80,1,0,"0000ae010613"],
	[30,80,80,1,0,"0000ae010621"],
	[40,80,80,1,0,"0000ae010629"],
	[50,80,80,1,0,"0000ae010637"],
	[60,80,80,1,0,"0000ae010645"],
	[70,80,80,1,0,"0000ae010653"],
	[80,80,80,1,0,"0000ae010661"],
	[90,80,80,1,0,"0000ae010669"],
	[100,80,80,1,0,"0000ae010677"],
	[110,80,80,1,0,"0000ae010685"],
	[120,80,80,1,0,"0000ae010693"],
	[130,80,80,1,0,"0000ae010701"],
	[140,80,80,1,0,"0000ae010709"],
	[150,80,80,1,0,"0000ae010717"],
	[30,90,80,1,0,"0000ae010725"],
	[40,90,80,1,0,"0000ae010733"],
	[50,90,80,1,0,"0000ae010741"],
	[60,90,80,1,0,"0000ae010749"],
	[70,90,80,1,0,"0000ae010757"],
	[80,90,80,1,0,"0000ae010765"],
	[90,90,80,1,0,"0000ae010773"],
	[100,90,80,1,0,"0000ae010781"],
	[110,90,80,1,0,"0000ae010789"],
	[120,90,80,1,0,"0000ae010797"],
	[130,90,80,1,0,"0000ae010805"],
	[140,90,80,1,0,"0000ae010813"],
	[150,90,80,1,0,"0000ae010821"],
	[30,20,90,1,0,"0000ae010829"],
	[40,20,90,1,0,"0000ae010837"],
	[50,20,90,1,0,"0000ae010845"],
	[60,20,90,1,0,"0000ae010853"],
	[70,20,90,1,0,"0000ae010861"],
	[80,20,90,1,0,"0000ae010869"],
	[90,20,90,1,0,"0000ae010877"],
	[100,20,90,1,0,"0000ae010885"],
	[110,20,90,1,0,"0000ae010893"],
	[120,20,90,1,0,"0000ae010901"],
	[130,20,90,1,0,"0000ae010909"],
	[140,20,90,1,0,"0000ae010917"],
	[150,20,90,1,0,"0000ae010925"],
	[30,30,90,1,0,"0000ae010933"],
	[40,30,90,1,0,"0000ae010941"],
	[50,30,90,1,0,"0000ae010949"],
	[60,30,90,1,0,"0000ae010957"],
	[70,30,90,1,0,"0000ae010965"],
	[80,30,90,1,0,"0000ae010973"],
	[90,30,90,1,0,"0000ae010981"],
	[100,30,90,1,0,"0000ae010989"],
	[110,30,90,1,0,"0000ae010997"],
	[120,30,90,1,0,"0000ae011005"],
	[130,30,90,1,0,"0000ae011013"],
	[140,30,90,1,0,"0000ae011021"],
	[150,30,90,1,0,"0000ae011029"],
	[30,40,90,1,0,"0000ae011037"],
	[40,40,90,1,0,"0000ae011045"],
	[50,40,90,1,0,"0000ae011053"],
	[60,40,90,1,0,"0000ae011061"],
	[70,40,90,1,0,"0000ae011069"],
	[80,40,90,1,0,"0000ae011077"],
	[90,40,90,1,0,"0000ae011085"],
	[100,40,90,1,0,"0000ae011093"],
	[110,40,90,1,0,"0000ae011101"],
	[120,40,90,1,0,"0000ae011109"],
	[130,40,90,1,0,"0000ae011117"],
	[140,40,90,1,0,"0000ae011125"],
	[150,40,90,1,0,"0000ae011133"],
	[30,50,90,1,0,"0000ae011141"],
	[40,50,90,1,0,"0000ae011149"],
	[50,50,90,1,0,"0000ae011157"],
	[60,50,90,1,0,"0000ae011165"],
	[70,50,90,1,0,"0000ae011173"],
	[80,50,90,1,0,"0000ae011181"],
	[90,50,90,1,0,"0000ae011189"],
	[100,50,90,1,0,"0000ae011197"],
	[110,50,90,1,0,"0000ae011205"],
	[120,50,90,1,0,"0000ae011213"],
	[130,50,90,1,0,"0000ae011221"],
	[140,50,90,1,0,"0000ae011229"],
	[150,50,90,1,0,"0000ae011237"],
	[30,60,90,1,0,"0000ae011245"],
	[40,60,90,1,0,"0000ae011253"],
	[50,60,90,1,0,"0000ae011261"],
	[60,60,90,1,0,"0000ae011269"],
	[70,60,90,1,0,"0000ae011277"],
	[80,60,90,1,0,"0000ae011285"],
	[90,60,90,1,0,"0000ae011293"],
	[100,60,90,1,0,"0000ae011301"],
	[110,60,90,1,0,"0000ae011309"],
	[120,60,90,1,0,"0000ae011317"],
	[130,60,90,1,0,"0000ae011325"],
	[140,60,90,1,0,"0000ae011333"],
	[150,60,90,1,0,"0000ae011341"],
	[30,70,90,1,0,"0000ae011349"],
	[40,70,90,1,0,"0000ae011357"],
	[50,70,90,1,0,"0000ae011365"],
	[60,70,90,1,0,"0000ae011373"],
	[70,70,90,1,0,"0000ae011381"],
	[80,70,90,1,0,"0000ae011389"],
	[90,70,90,1,0,"0000ae011397"],
	[100,70,90,1,0,"0000ae011405"],
	[110,70,90,1,0,"0000ae011413"],
	[120,70,90,1,0,"0000ae011421"],
	[130,70,90,1,0,"0000ae011429"],
	[140,70,90,1,0,"0000ae011437"],
	[150,70,90,1,0,"0000ae011445"],
	[30,80,90,1,0,"0000ae011453"],
	[40,80,90,1,0,"0000ae011461"],
	[50,80,90,1,0,"0000ae011469"],
	[60,80,90,1,0,"0000ae011477"],
	[70,80,90,1,0,"0000ae011485"],
	[80,80,90,1,0,"0000ae011493"],
	[90,80,90,1,0,"0000ae011501"],
	[100,80,90,1,0,"0000ae011509"],
	[110,80,90,1,0,"0000ae011517"],
	[120,80,90,1,0,"0000ae011525"],
	[130,80,90,1,0,"0000ae011533"],
	[140,80,90,1,0,"0000ae011541"],
	[150,80,90,1,0,"0000ae011549"],
	[30,90,90,1,0,"0000ae011557"],
	[40,90,90,1,0,"0000ae011565"],
	[50,90,90,1,0,"0000ae011573"],
	[60,90,90,1,0,"0000ae011581"],
	[70,90,90,1,0,"0000ae011589"],
	[80,90,90,1,0,"0000ae011597"],
	[90,90,90,1,0,"0000ae011605"],
	[100,90,90,1,0,"0000ae011613"],
	[110,90,90,1,0,"0000ae011621"],
	[120,90,90,1,0,"0000ae011629"],
	[130,90,90,1,0,"0000ae011637"],
	[140,90,90,1,0,"0000ae011645"],
	[150,90,90,1,0,"0000ae011653"],
	[30,20,100,1,0,"0000ae011661"],
	[40,20,100,1,0,"0000ae011669"],
	[50,20,100,1,0,"0000ae011677"],
	[60,20,100,1,0,"0000ae011685"],
	[70,20,100,1,0,"0000ae011693"],
	[80,20,100,1,0,"0000ae011701"],
	[90,20,100,1,0,"0000ae011709"],
	[100,20,100,1,0,"0000ae011717"],
	[110,20,100,1,0,"0000ae011725"],
	[120,20,100,1,0,"0000ae011733"],
	[130,20,100,1,0,"0000ae011741"],
	[140,20,100,1,0,"0000ae011749"],
	[150,20,100,1,0,"0000ae011757"],
	[30,30,100,1,0,"0000ae011765"],
	[40,30,100,1,0,"0000ae011773"],
	[50,30,100,1,0,"0000ae011781"],
	[60,30,100,1,0,"0000ae011789"],
	[70,30,100,1,0,"0000ae011797"],
	[80,30,100,1,0,"0000ae011805"],
	[90,30,100,1,0,"0000ae011813"],
	[100,30,100,1,0,"0000ae011821"],
	[110,30,100,1,0,"0000ae011829"],
	[120,30,100,1,0,"0000ae011837"],
	[130,30,100,1,0,"0000ae011845"],
	[140,30,100,1,0,"0000ae011853"],
	[150,30,100,1,0,"0000ae011861"],
	[30,40,100,1,0,"0000ae011869"],
	[40,40,100,1,0,"0000ae011877"],
	[50,40,100,1,0,"0000ae011885"],
	[60,40,100,1,0,"0000ae011893"],
	[70,40,100,1,0,"0000ae011901"],
	[80,40,100,1,0,"0000ae011909"],
	[90,40,100,1,0,"0000ae011917"],
	[100,40,100,1,0,"0000ae011925"],
	[110,40,100,1,0,"0000ae011933"],
	[120,40,100,1,0,"0000ae011941"],
	[130,40,100,1,0,"0000ae011949"],
	[140,40,100,1,0,"0000ae011957"],
	[150,40,100,1,0,"0000ae011965"],
	[30,50,100,1,0,"0000ae011973"],
	[40,50,100,1,0,"0000ae011981"],
	[50,50,100,1,0,"0000ae011989"],
	[60,50,100,1,0,"0000ae011997"],
	[70,50,100,1,0,"0000ae012005"],
	[80,50,100,1,0,"0000ae012013"],
	[90,50,100,1,0,"0000ae012021"],
	[100,50,100,1,0,"0000ae012029"],
	[110,50,100,1,0,"0000ae012037"],
	[120,50,100,1,0,"0000ae012045"],
	[130,50,100,1,0,"0000ae012053"],
	[140,50,100,1,0,"0000ae012061"],
	[150,50,100,1,0,"0000ae012069"],
	[30,60,100,1,0,"0000ae012077"],
	[40,60,100,1,0,"0000ae012085"],
	[50,60,100,1,0,"0000ae012093"],
	[60,60,100,1,0,"0000ae012101"],
	[70,60,100,1,0,"0000ae012109"],
	[80,60,100,1,0,"0000ae012117"],
	[90,60,100,1,0,"0000ae012125"],
	[100,60,100,1,0,"0000ae012133"],
	[110,60,100,1,0,"0000ae012141"],
	[120,60,100,1,0,"0000ae012149"],
	[130,60,100,1,0,"0000ae012157"],
	[140,60,100,1,0,"0000ae012165"],
	[150,60,100,1,0,"0000ae012173"],
	[30,70,100,1,0,"0000ae012181"],
	[40,70,100,1,0,"0000ae012189"],
	[50,70,100,1,0,"0000ae012197"],
	[60,70,100,1,0,"0000ae012205"],
	[70,70,100,1,0,"0000ae012213"],
	[80,70,100,1,0,"0000ae012221"],
	[90,70,100,1,0,"0000ae012229"],
	[100,70,100,1,0,"0000ae012237"],
	[110,70,100,1,0,"0000ae012245"],
	[120,70,100,1,0,"0000ae012253"],
	[130,70,100,1,0,"0000ae012261"],
	[140,70,100,1,0,"0000ae012269"],
	[150,70,100,1,0,"0000ae012277"],
	[30,80,100,1,0,"0000ae012285"],
	[40,80,100,1,0,"0000ae012293"],
	[50,80,100,1,0,"0000ae012301"],
	[60,80,100,1,0,"0000ae012309"],
	[70,80,100,1,0,"0000ae012317"],
	[80,80,100,1,0,"0000ae012325"],
	[90,80,100,1,0,"0000ae012333"],
	[100,80,100,1,0,"0000ae012341"],
	[110,80,100,1,0,"0000ae012349"],
	[120,80,100,1,0,"0000ae012357"],
	[130,80,100,1,0,"0000ae012365"],
	[140,80,100,1,0,"0000ae012373"],
	[150,80,100,1,0,"0000ae012381"],
	[30,90,100,1,0,"0000ae012389"],
	[40,90,100,1,0,"0000ae012397"],
	[50,90,100,1,0,"0000ae012405"],
	[60,90,100,1,0,"0000ae012413"],
	[70,90,100,1,0,"0000ae012421"],
	[80,90,100,1,0,"0000ae012429"],
	[90,90,100,1,0,"0000ae012437"],
	[100,90,100,1,0,"0000ae012445"],
	[110,90,100,1,0,"0000ae012453"],
	[120,90,100,1,0,"0000ae012461"],
	[130,90,100,1,0,"0000ae012469"],
	[140,90,100,1,0,"0000ae012477"],
	[150,90,100,1,0,"0000ae012485"],*/

  ];
});//jQuery終了



